/* -------------------------------- General ------------------------------- */

// Listing Status is the superset on Listing State.
// If listing has no status, it will be borrowed from Listing State (draft -> draft, published -> forSale, closed -> unavailable).
export const LISTING_STATUS = {
  // Draft
  DRAFT: 'draft',
  // Published
  FOR_SALE: 'forSale',
  UNDER_NEGOTIATION: 'underNegotiation',
  // Closed
  UNAVAILABLE: 'unavailable',
  // Permanently closed:
  SOLD: 'sold',
  CANCELED: 'canceled',
};

export const LISTING_SALE_CLASS = {
  NEW: 'new',
  USED: 'used',
};

export const LISTING_CONDITION = {
  AS_NEW: 'as-new',
  GOOD: 'good',
  FAIR: 'fair',
  POOR: 'poor',
  DAMAGED: 'damaged',
};

export const LISTING_CATEGORY = {
  POWER_BOATS: 'powerBoats',
  SAILING_BOATS: 'sailingBoats',
  SLOEP: 'sloopsBoats',
  INFLATABLE_BOATS: 'inflatableBoats',
  JETSKI: 'jetski',
  BOAT_ENGINES: 'boatEngines',
  TRAILERS: 'trailers',
  MOORING: 'mooring',
  OTHER: 'other',
};

export const LISTING_TYPE = {
  CABIN: 'cabin',
  CATAMARAN: 'catamaran',
  CLASSIC: 'classic',
  CRUISING: 'cruising',
  DAYSAILER: 'daysailer',
  DECKSALOON: 'decksaloon',
  DINGHY: 'dinghy',
  FLAT: 'flat',
  GULET: 'gulet',
  HULL: 'hull',
  MOTORSAILER: 'motorsailer',
  RACING: 'racing',
  TRIMARAN: 'trimaran',
  YACHT: 'yacht',
  AIRBOAT: 'airboat',
  BOWRIDER: 'bowrider',
  CARGO: 'cargo',
  CENTERCONSOLE: 'centerconsole',
  CRUISER: 'cruiser',
  CUDDYCABIN: 'cuddycabin',
  DAYCRUISER: 'daycruiser',
  DECK: 'deck',
  DIVING: 'diving',
  DUALCONSOLE: 'dualconsole',
  FISHING: 'fishing',
  FLOATINGHOME: 'floatinghome',
  HARDTOP: 'hardtop',
  HIGHPERFORMANCE: 'highperformance',
  HOUSEBOAT: 'houseboat',
  NARROW: 'narrow',
  PASSENGER: 'passenger',
  PILOTHOUSE: 'pilothouse',
  PONTOON: 'pontoon',
  RUNABOUT: 'runabout',
  SLOEP: 'sloep',
  SKIANWAKE: 'skiandwake',
  SPORT: 'sport',
  SUBMARINE: 'submarine',
  TRAWLER: 'trawler',
  UTILITY: 'utility',
  WALKAROUND: 'walkaround',
  RIB: 'rib',
  SOFT: 'soft',
  RAFTING: 'rafting',
  CANOE: 'canoe',
  KAYAK: 'kayak',
  PEDAL: 'pedal',
  ROWING: 'rowing',
  JETSKI: 'jetski',
  GADGET: 'gadget',
  INBOARD: 'inboard',
  OUTBOARD: 'outboard',
  INBOARD_OUTBOARD: 'inboard-outboard',
  ELECTRIC: 'electric',
  POD: 'pod',
  JET: 'jet',
  SAILDRIVE: 'saildrive',
  SHAFT: 'shaft',
  SURFACE_DRIVE: 'surface drive',
  STERN_DRIVE: 'stern drive',
  OTHERS: 'others',
  UNBRAKED: 'unbraked',
  BRAKED: 'braked',
  MULTIROLLER: 'multiroller',
  BUNK: 'bunk',
  CUSTOM: 'custom',
  FLATBED: 'flatbed',
  BOATLIFT: 'boatlift',
  NO_TRAILER: 'no trailer',
  MARINA: 'marina',
  BOATHOUSE: 'boathouse',
  DRYDOCK: 'drydock',
  SHORE: 'shore',
  MOORING_BUOY: 'mooring-buoy',
  FLOATING: 'floating',
  SLIPWAY: 'slipway',
  WINTERSTORAGE: 'winterstorage',
  OTHER: 'other',

  HARBOUR: 'harbour',
  ROAD: 'road',
  STORAGE: 'storage',
  TROLLEY: 'trolley',

  HANGAR_HEATED: 'hangar-heated',
  HANGAR_UNHEATED: 'hangar-unheated',
  JETTY: 'jetty',
  SWIMMING: 'swimming',

  /*ENTERTAINMENT: 'entertainment',
  COVERS: 'covers',
  INTERIOR: 'interior',
  LAYOUT: 'layout',
  NAVIGATION: 'navigation',
  SAFETY: 'safety',
  TECHNICS: 'technics',*/
};

export const LISTING_HULL_TYPE = {
  DISPLACEMENT: 'displacement',
  PLANING: 'planing',
  SEMI_DISPLACEMENT: 'semiDisplacement',
};

export const LISTING_TYPES_PER_CATEGORY = {
  [LISTING_CATEGORY.POWER_BOATS]: [
    LISTING_TYPE.AIRBOAT,
    LISTING_TYPE.BOWRIDER,
    LISTING_TYPE.CABIN,
    LISTING_TYPE.CARGO,
    LISTING_TYPE.CATAMARAN,
    LISTING_TYPE.CENTERCONSOLE,
    LISTING_TYPE.CLASSIC,
    LISTING_TYPE.CRUISER,
    LISTING_TYPE.CUDDYCABIN,
    LISTING_TYPE.DAYCRUISER,
    LISTING_TYPE.DECK,
    LISTING_TYPE.DIVING,
    LISTING_TYPE.DUALCONSOLE,
    LISTING_TYPE.FISHING,
    LISTING_TYPE.FLOATINGHOME,
    LISTING_TYPE.HARDTOP,
    LISTING_TYPE.HIGHPERFORMANCE,
    LISTING_TYPE.HOUSEBOAT,
    LISTING_TYPE.HULL,
    LISTING_TYPE.NARROW,
    LISTING_TYPE.PASSENGER,
    LISTING_TYPE.PILOTHOUSE,
    LISTING_TYPE.PONTOON,
    LISTING_TYPE.RUNABOUT,
    LISTING_TYPE.SKIANWAKE,
    LISTING_TYPE.SPORT,
    LISTING_TYPE.SUBMARINE,
    LISTING_TYPE.TRAWLER,
    LISTING_TYPE.TRIMARAN,
    LISTING_TYPE.UTILITY,
    LISTING_TYPE.WALKAROUND,
    LISTING_TYPE.YACHT,
  ],
  [LISTING_CATEGORY.SAILING_BOATS]: [
    LISTING_TYPE.CABIN,
    LISTING_TYPE.CATAMARAN,
    LISTING_TYPE.CLASSIC,
    LISTING_TYPE.CRUISING,
    LISTING_TYPE.DAYSAILER,
    LISTING_TYPE.DECKSALOON,
    LISTING_TYPE.DINGHY,
    LISTING_TYPE.FLAT,
    LISTING_TYPE.GULET,
    LISTING_TYPE.HULL,
    LISTING_TYPE.MOTORSAILER,
    LISTING_TYPE.RACING,
    LISTING_TYPE.TRIMARAN,
    LISTING_TYPE.YACHT,
  ],
  [LISTING_CATEGORY.SLOEP]: [LISTING_TYPE.SLOEP],
  [LISTING_CATEGORY.INFLATABLE_BOATS]: [LISTING_TYPE.RIB, LISTING_TYPE.SOFT, LISTING_TYPE.RAFTING],
  [LISTING_CATEGORY.JETSKI]: [LISTING_TYPE.JETSKI],
  [LISTING_CATEGORY.BOAT_ENGINES]: [
    LISTING_TYPE.INBOARD,
    LISTING_TYPE.OUTBOARD,
    LISTING_TYPE.INBOARD_OUTBOARD,
    LISTING_TYPE.ELECTRIC,
    LISTING_TYPE.POD,
    LISTING_TYPE.JET,
    LISTING_TYPE.SAILDRIVE,
    LISTING_TYPE.SHAFT,
    LISTING_TYPE.SURFACE_DRIVE,
    LISTING_TYPE.STERN_DRIVE,
    LISTING_TYPE.OTHERS,
  ],
  [LISTING_CATEGORY.TRAILERS]: [
    LISTING_TYPE.UNBRAKED,
    LISTING_TYPE.BRAKED,
    LISTING_TYPE.MULTIROLLER,
    LISTING_TYPE.BUNK,
    LISTING_TYPE.CUSTOM,
    LISTING_TYPE.FLATBED,
    LISTING_TYPE.NO_TRAILER,

    LISTING_TYPE.HARBOUR,
    LISTING_TYPE.ROAD,
    LISTING_TYPE.STORAGE,
    LISTING_TYPE.TROLLEY,
  ],
  [LISTING_CATEGORY.MOORING]: [
    LISTING_TYPE.MARINA,
    LISTING_TYPE.BOATHOUSE,
    LISTING_TYPE.DRYDOCK,
    LISTING_TYPE.SHORE,
    LISTING_TYPE.MOORING_BUOY,
    LISTING_TYPE.FLOATING,
    LISTING_TYPE.SLIPWAY,

    LISTING_TYPE.HANGAR_HEATED,
    LISTING_TYPE.HANGAR_UNHEATED,
    LISTING_TYPE.JETTY,
    LISTING_TYPE.SWIMMING,
  ],
  [LISTING_CATEGORY.OTHER]: [
    LISTING_TYPE.CANOE,
    LISTING_TYPE.DINGHY,
    LISTING_TYPE.FISHING,
    LISTING_TYPE.KAYAK,
    LISTING_TYPE.PEDAL,
    LISTING_TYPE.ROWING,
    LISTING_TYPE.GADGET,
    LISTING_TYPE.BOATLIFT,
    /*LISTING_TYPE.COVERS,
    LISTING_TYPE.ENTERTAINMENT,
    LISTING_TYPE.INTERIOR,
    LISTING_TYPE.LAYOUT,
    LISTING_TYPE.NAVIGATION,
    LISTING_TYPE.SAFETY,
    LISTING_TYPE.TECHNICS,*/
    LISTING_TYPE.OTHER,
  ],
};

export const LISTING_FILTERS_CONFIG = {
  [LISTING_CATEGORY.POWER_BOATS]: [
    LISTING_TYPE.AIRBOAT,
    LISTING_TYPE.BOWRIDER,
    LISTING_TYPE.CABIN,
    LISTING_TYPE.CARGO,
    LISTING_TYPE.CATAMARAN,
    LISTING_TYPE.CENTERCONSOLE,
    LISTING_TYPE.CLASSIC,
    LISTING_TYPE.CRUISER,
    LISTING_TYPE.CUDDYCABIN,
    LISTING_TYPE.DAYCRUISER,
    LISTING_TYPE.DECK,
    LISTING_TYPE.DIVING,
    LISTING_TYPE.DUALCONSOLE,
    LISTING_TYPE.FISHING,
    LISTING_TYPE.FLOATINGHOME,
    LISTING_TYPE.HARDTOP,
    LISTING_TYPE.HIGHPERFORMANCE,
    LISTING_TYPE.HOUSEBOAT,
    LISTING_TYPE.HULL,
    LISTING_TYPE.NARROW,
    LISTING_TYPE.PASSENGER,
    LISTING_TYPE.PILOTHOUSE,
    LISTING_TYPE.PONTOON,
    LISTING_TYPE.RUNABOUT,
    LISTING_TYPE.SKIANWAKE,
    LISTING_TYPE.SPORT,
    LISTING_TYPE.SUBMARINE,
    LISTING_TYPE.TRAWLER,
    LISTING_TYPE.TRIMARAN,
    LISTING_TYPE.UTILITY,
    LISTING_TYPE.WALKAROUND,
    LISTING_TYPE.YACHT,
  ],
  [LISTING_CATEGORY.SAILING_BOATS]: [
    LISTING_TYPE.CABIN,
    LISTING_TYPE.CATAMARAN,
    LISTING_TYPE.CLASSIC,
    LISTING_TYPE.CRUISING,
    LISTING_TYPE.DAYSAILER,
    LISTING_TYPE.DECKSALOON,
    LISTING_TYPE.DINGHY,
    LISTING_TYPE.FLAT,
    LISTING_TYPE.GULET,
    LISTING_TYPE.HULL,
    LISTING_TYPE.MOTORSAILER,
    LISTING_TYPE.RACING,
    LISTING_TYPE.TRIMARAN,
    LISTING_TYPE.YACHT,
  ],
  [LISTING_CATEGORY.SLOEP]: [LISTING_TYPE.SLOEP],
  [LISTING_CATEGORY.INFLATABLE_BOATS]: [LISTING_TYPE.RIB, LISTING_TYPE.SOFT, LISTING_TYPE.RAFTING],
  [LISTING_CATEGORY.JETSKI]: [LISTING_TYPE.JETSKI],
  [LISTING_CATEGORY.BOAT_ENGINES]: [
    LISTING_TYPE.INBOARD,
    LISTING_TYPE.OUTBOARD,
    LISTING_TYPE.INBOARD_OUTBOARD,
    LISTING_TYPE.ELECTRIC,
    LISTING_TYPE.POD,
    LISTING_TYPE.JET,
    LISTING_TYPE.SAILDRIVE,
    LISTING_TYPE.SHAFT,
    LISTING_TYPE.SURFACE_DRIVE,
    LISTING_TYPE.STERN_DRIVE,
    LISTING_TYPE.OTHERS,
  ],
  [LISTING_CATEGORY.TRAILERS]: [
    LISTING_TYPE.UNBRAKED,
    LISTING_TYPE.BRAKED,
    LISTING_TYPE.MULTIROLLER,
    LISTING_TYPE.BUNK,
    LISTING_TYPE.CUSTOM,
    LISTING_TYPE.FLATBED,
    LISTING_TYPE.NO_TRAILER,

    LISTING_TYPE.HARBOUR,
    LISTING_TYPE.ROAD,
    LISTING_TYPE.STORAGE,
    LISTING_TYPE.TROLLEY,
  ],
  [LISTING_CATEGORY.MOORING]: [
    LISTING_TYPE.MARINA,
    LISTING_TYPE.BOATHOUSE,
    LISTING_TYPE.DRYDOCK,
    LISTING_TYPE.SHORE,
    LISTING_TYPE.MOORING_BUOY,
    LISTING_TYPE.FLOATING,
    LISTING_TYPE.SLIPWAY,

    LISTING_TYPE.HANGAR_HEATED,
    LISTING_TYPE.HANGAR_UNHEATED,
    LISTING_TYPE.JETTY,
    LISTING_TYPE.SWIMMING,
  ],
  [LISTING_CATEGORY.OTHER]: [
    LISTING_TYPE.GADGET,
    LISTING_TYPE.BOATLIFT,
    'rowingFilter',
    LISTING_TYPE.OTHER,
  ],
};

export const TYPES_EXCLUDED_FROM_FILTERS = [
  { category: LISTING_CATEGORY.POWER_BOATS, type: LISTING_TYPE.AIRBOAT },
  { category: LISTING_CATEGORY.POWER_BOATS, type: LISTING_TYPE.CABIN },
  { category: LISTING_CATEGORY.POWER_BOATS, type: LISTING_TYPE.DIVING },
  { category: LISTING_CATEGORY.POWER_BOATS, type: LISTING_TYPE.HARDTOP },
  { category: LISTING_CATEGORY.POWER_BOATS, type: LISTING_TYPE.HIGHPERFORMANCE },
  { category: LISTING_CATEGORY.POWER_BOATS, type: LISTING_TYPE.NARROW },
  { category: LISTING_CATEGORY.POWER_BOATS, type: LISTING_TYPE.SUBMARINE },
  { category: LISTING_CATEGORY.TRAILERS, type: LISTING_TYPE.NO_TRAILER },
  { category: LISTING_CATEGORY.MOORING, type: LISTING_TYPE.BUOY },

  { category: LISTING_CATEGORY.TRAILERS, type: LISTING_TYPE.HARBOUR },
  { category: LISTING_CATEGORY.TRAILERS, type: LISTING_TYPE.ROAD },
  { category: LISTING_CATEGORY.TRAILERS, type: LISTING_TYPE.STORAGE },
  { category: LISTING_CATEGORY.TRAILERS, type: LISTING_TYPE.TROLLEY },

  { category: LISTING_CATEGORY.MOORING, type: LISTING_TYPE.HANGAR_HEATED },
  { category: LISTING_CATEGORY.MOORING, type: LISTING_TYPE.HANGAR_UNHEATED },
  { category: LISTING_CATEGORY.MOORING, type: LISTING_TYPE.JETTY },
  { category: LISTING_CATEGORY.MOORING, type: LISTING_TYPE.SWIMMING },
];

/* -------------------------------- Equipment ------------------------------- */

export const LISTING_EQUIPMENT_CATEGORY = {
  NAVIGATION: 'navigation',
  TECHNICS: 'technics',
  INTERIOR: 'interior',
  ENTERTAINMENT: 'entertainment',
  COVERS: 'covers',
  SAFETY: 'safety',
  LAYOUT: 'layout',
};

export const LISTING_EQUIPMENT_TYPE = {
  AIS: 'ais',
  ALARM_SYSTEM: 'alarmSystem',
  ANCHOR: 'anchor',
  AUTOMATIC_STEERING_GEAR: 'automaticSteeringGear',
  AUTOPILOT: 'autopilot',
  BATTERY_CHARGER: 'batteryCharger',
  BATTERY: 'battery',
  BIMINI_TOP: 'biminiTop',
  CD_PLAYER: 'cdPlayer',
  COMPASS: 'compass',
  DEPTH_INSTRUMENT: 'depthInstrument',
  DVD_PLAYER: 'dvdPlayer',
  FIRE_EXTINGUISH_SYSTEM: 'fireExtinguishSystem',
  FIRE_EXTINGUISHER_SYSTEM: 'fireExtinguisherSystem',
  FIRE_EXTINGUISHER: 'fireExtinguisher',
  FISHFINDER: 'fishfinder',
  FREEZER: 'freezer',
  FRIDGE: 'fridge',
  FULL_COVER: 'fullCover',
  GAS_DETECTOR: 'gasDetector',
  GENERATOR: 'generator',
  GPS: 'gps',
  INSIDE_STEERING: 'insideSteering',
  INVERTER: 'inverter',
  LIFE_BELTS: 'lifeBelts',
  LIFE_JACKETS: 'lifeJackets',
  LIFE_RAFT: 'lifeRaft',
  MICROWAVE: 'microwave',
  NAVIGATION_LIGHTS: 'navigationLights',
  NAVTEX: 'navtex',
  ON_BOARD_COMPUTER: 'onBoardComputer',
  OUTSIDE_STEERING: 'outsideSteering',
  OVEN: 'oven',
  PLOTTER: 'plotter',
  RADAR: 'radar',
  RADIO: 'radio',
  REV_COUNTER: 'revCounter',
  RUDDER_INDICATOR: 'rudderIndicator',
  SHORE_CONNECTION: 'shoreConnection',
  SPEED_INSTRUMENT: 'speedInstrument',
  SPRAY_HOOD: 'sprayHood',
  SSD: 'ssd',
  STOVE: 'stove',
  TV: 'tv',
  VHF: 'vhf',
  WIND_INSTRUMENT: 'windInstrument',
  WINTER_COVER: 'winterCover',
};

export const LISTING_BOAT_EQUIPMENT = {
  AIR_CONDITIONING: 'airConditioning',
  BATHING_PLATFORM_ELECTRIC: 'bathingPlatformElectric',
  BATHING_PLATFORM_FIX: 'bathingPlatformFix',
  BATHING_PLATFORM_MANUAL: 'bathingPlatformManual',
  BBQ_GRILL: 'bbqGrill',
  BLUETOOTH_CONNECTOR: 'bluetoothConnector',
  CD_PLAYER: LISTING_EQUIPMENT_TYPE.CD_PLAYER,
  COCKPIT_SPEAKERS: 'cockpitSpeakers',
  COCKPIT_TABLE: 'cockpitTable',
  DAVITS: 'davits',
  DECK_SHOWER: 'deckShower',
  DVBT_ANTENNA: 'dvbtAntenna',
  DVD_PLAYER: LISTING_EQUIPMENT_TYPE.DVD_PLAYER,
  ELECTRIC_GANGWAY: 'electricGangway',
  GANGWAY: 'gangway',
  HEATING: 'heating',
  ICEMAKER: 'icemaker',
  IPOD_INTERFACE: 'ipodInterface',
  MP3_PLAYER: 'mp3Player',
  RADIO: LISTING_EQUIPMENT_TYPE.RADIO,
  SATELLITE_ANTENNA: 'satelliteAntenna',
  SATELLITE_INTERNET: 'satelliteInternet',
  SATELLITE_PHONE: 'satellitePhone',
  SWIM_LADDER: 'swimLadder',
  TEAK_COCKPIT: 'teakCockpit',
  TEAK_DECK: 'teakDeck',
  TRAILER: 'trailer',
  TV: LISTING_EQUIPMENT_TYPE.TV,
  UNDERWATER_PAINT: 'underwaterPaint',
  WETBAR: 'wetbar',
};

export const LISTING_EQUIPMENT_TYPES_PER_LISTING_EQUIPMENT_CATEGORY = {
  [LISTING_EQUIPMENT_CATEGORY.NAVIGATION]: [
    LISTING_EQUIPMENT_TYPE.AIS,
    LISTING_EQUIPMENT_TYPE.AUTOMATIC_STEERING_GEAR,
    LISTING_EQUIPMENT_TYPE.AUTOPILOT,
    LISTING_EQUIPMENT_TYPE.COMPASS,
    LISTING_EQUIPMENT_TYPE.DEPTH_INSTRUMENT,
    LISTING_EQUIPMENT_TYPE.FISHFINDER,
    LISTING_EQUIPMENT_TYPE.GPS,
    LISTING_EQUIPMENT_TYPE.NAVIGATION_LIGHTS,
    LISTING_EQUIPMENT_TYPE.NAVTEX,
    LISTING_EQUIPMENT_TYPE.ON_BOARD_COMPUTER,
    LISTING_EQUIPMENT_TYPE.PLOTTER,
    LISTING_EQUIPMENT_TYPE.RADAR,
    LISTING_EQUIPMENT_TYPE.REV_COUNTER,
    LISTING_EQUIPMENT_TYPE.RUDDER_INDICATOR,
    LISTING_EQUIPMENT_TYPE.SPEED_INSTRUMENT,
    LISTING_EQUIPMENT_TYPE.SSD,
    LISTING_EQUIPMENT_TYPE.VHF,
    LISTING_EQUIPMENT_TYPE.WIND_INSTRUMENT,
  ],
  [LISTING_EQUIPMENT_CATEGORY.TECHNICS]: [
    LISTING_EQUIPMENT_TYPE.ALARM_SYSTEM,
    LISTING_EQUIPMENT_TYPE.ANCHOR,
    LISTING_EQUIPMENT_TYPE.BATTERY_CHARGER,
    LISTING_EQUIPMENT_TYPE.BATTERY,
    LISTING_EQUIPMENT_TYPE.FIRE_EXTINGUISHER_SYSTEM,
    LISTING_EQUIPMENT_TYPE.FIRE_EXTINGUISHER,
    LISTING_EQUIPMENT_TYPE.GAS_DETECTOR,
    LISTING_EQUIPMENT_TYPE.GENERATOR,
    LISTING_EQUIPMENT_TYPE.INVERTER,
    LISTING_EQUIPMENT_TYPE.SHORE_CONNECTION,
  ],
  [LISTING_EQUIPMENT_CATEGORY.INFLATABLE_BOATS]: [
    LISTING_EQUIPMENT_TYPE.FREEZER,
    LISTING_EQUIPMENT_TYPE.FRIDGE,
    LISTING_EQUIPMENT_TYPE.MICROWAVE,
    LISTING_EQUIPMENT_TYPE.OVEN,
    LISTING_EQUIPMENT_TYPE.STOVE,
  ],
  [LISTING_EQUIPMENT_CATEGORY.ENTERTAINMENT]: [
    LISTING_EQUIPMENT_TYPE.CD_PLAYER,
    LISTING_EQUIPMENT_TYPE.DVD_PLAYER,
    LISTING_EQUIPMENT_TYPE.RADIO,
    LISTING_EQUIPMENT_TYPE.TV,
  ],
  [LISTING_EQUIPMENT_CATEGORY.COVERS]: [
    LISTING_EQUIPMENT_TYPE.BIMINI_TOP,
    LISTING_EQUIPMENT_TYPE.FULL_COVER,
    LISTING_EQUIPMENT_TYPE.SPRAY_HOOD,
    LISTING_EQUIPMENT_TYPE.WINTER_COVER,
  ],
  [LISTING_EQUIPMENT_CATEGORY.SAFETY]: [
    LISTING_EQUIPMENT_TYPE.FIRE_EXTINGUISH_SYSTEM,
    LISTING_EQUIPMENT_TYPE.LIFE_BELTS,
    LISTING_EQUIPMENT_TYPE.LIFE_JACKETS,
    LISTING_EQUIPMENT_TYPE.LIFE_RAFT,
  ],
  [LISTING_EQUIPMENT_CATEGORY.LAYOUT]: [
    LISTING_EQUIPMENT_TYPE.INSIDE_STEERING,
    LISTING_EQUIPMENT_TYPE.OUTSIDE_STEERING,
  ],
};

/* -------------------------------- Engine ------------------------------- */

export const LISTING_ENGINE_PROPULSION = {
  FORWARD: 'forward',
  HYDRAULIC: 'hydraulic',
  JET: 'jet',
  OUTBOARD: 'outboard',
  POD: 'pod',
  SAIL: 'sail',
  SHAFT: 'shaft',
  STERN: 'stern',
  SURFACE: 'surface',
  VDRIVE: 'vdrive',
};

export const LISTING_ENGINE_FUEL_TYPE = {
  DIESEL: 'diesel',
  ELECTRIC: 'electric',
  ETHANOL: 'ethanol',
  GAS: 'gas',
  GASOLINE_OIL: 'gasoline-oil',
  GASOLINE: 'gasoline',
  HYBRID: 'hybrid',
  PROPANE: 'propane',
  SOLAR: 'solar',
};

/* --------------------------- Technical Equipment -------------------------- */

export const LISTING_TECHNICAL_EQUIPMENT = {
  ALARM_SYSTEM: LISTING_EQUIPMENT_TYPE.ALARM_SYSTEM,
  ANCHOR: LISTING_EQUIPMENT_TYPE.ANCHOR,
  BATTERY_CHARGER: LISTING_EQUIPMENT_TYPE.BATTERY_CHARGER,
  BATTERY: LISTING_EQUIPMENT_TYPE.BATTERY,
  BILGE_PUMP: 'bilgePump',
  BOW_ANCHOR_CAPSTAN: 'bowAnchorCapstan',
  BOW_THRUSTER: 'bowThruster',
  CLOTHES_DRYER: 'clothesDryer',
  DECK_WASHER: 'deckWasher',
  ELECTRIC_TOILET: 'electricToilet',
  FIRE_EXTINGUISHER_SYSTEM: LISTING_EQUIPMENT_TYPE.FIRE_EXTINGUISHER_SYSTEM,
  FIRE_EXTINGUISHER: LISTING_EQUIPMENT_TYPE.FIRE_EXTINGUISHER,
  GAS_DETECTOR: LISTING_EQUIPMENT_TYPE.GAS_DETECTOR,
  GENERATOR: LISTING_EQUIPMENT_TYPE.GENERATOR,
  GYROSCOPIC_STABILIZER: 'gyroscopicStabilizer',
  INVERTER: LISTING_EQUIPMENT_TYPE.INVERTER,
  LIFE_RAFT: LISTING_EQUIPMENT_TYPE.LIFE_RAFT,
  NAVIGATION_LIGHTS: LISTING_EQUIPMENT_TYPE.NAVIGATION_LIGHTS,
  SHORE_CONNECTION: LISTING_EQUIPMENT_TYPE.SHORE_CONNECTION,
  SOLAR_PANELS: 'solarPanels',
  STERN_ANCHOR_CAPSTAN: 'sternAnchorCapstan',
  STERN_THRUSTER: 'sternThruster',
  TRIM_TABS: 'trimTabs',
  UNDERWATER_LIGHTS: 'underwaterLights',
  WARM_WATER_SYSTEM: 'warmWaterSystem',
  WASHING_MACHINE: 'washingMachine',
  WATER_PRESSURE_SYSTEM: 'waterPressureSystem',
  WATERMAKER: 'watermaker',
};

/* -------------------------- On-Board Instruments¸ ------------------------- */

export const LISTING_ON_BOARD_INSTRUMENTS = {
  AIS: LISTING_EQUIPMENT_TYPE.AIS,
  AUTOPILOT: LISTING_EQUIPMENT_TYPE.AUTOPILOT,
  BOARD_COMPUTER: 'boardComputer',
  CHARTPLOTTER: 'chartplotter',
  COMPASS: LISTING_EQUIPMENT_TYPE.COMPASS,
  DEPTH_INSTRUMENT: LISTING_EQUIPMENT_TYPE.DEPTH_INSTRUMENT,
  EPIRB: 'epirb',
  FISHFINDER: LISTING_EQUIPMENT_TYPE.FISHFINDER,
  GPS: LISTING_EQUIPMENT_TYPE.GPS,
  MOB_SYSTEM: 'mobSystem',
  RADAR_REFLECTOR: 'radarReflector',
  RADAR: 'radar',
  SPEED_INSTRUMENT: LISTING_EQUIPMENT_TYPE.SPEED_INSTRUMENT,
  VHF_RADIO: 'vhfRadio',
  WIND_INSTRUMENT: LISTING_EQUIPMENT_TYPE.WIND_INSTRUMENT,
  WINDVANE_SELF_STEERING: 'windvaneSelfSteering',
};

/* --------------------------------- Galley --------------------------------- */

export const LISTING_GALLEY = {
  CERAN_STOVE: 'ceranStove',
  COOL_BOX: 'coolBox',
  DISHWASHER: 'dishwasher',
  ELECTRIC_STOVE: 'electricStove',
  EXTRACTOR_HOOD: 'extractorHood',
  FREEZER: LISTING_EQUIPMENT_TYPE.FREEZER,
  FRIDGE: LISTING_EQUIPMENT_TYPE.FRIDGE,
  GAS_STOVE: 'gasStove',
  MICROWAVE: LISTING_EQUIPMENT_TYPE.MICROWAVE,
  OVEN: LISTING_EQUIPMENT_TYPE.OVEN,
  SINK: 'sink',
  STOVE: LISTING_EQUIPMENT_TYPE.STOVE,
};

/* -------------------------- Covers and Tarpaulins ------------------------- */

export const LISTING_COVERS_AND_TARPAULINS = {
  BIMINI_TOP: LISTING_EQUIPMENT_TYPE.BIMINI_TOP,
  COCKPIT_COVER: 'cockpitCover',
  FLYBRIDGE_COVER: 'flybridgeCover',
  FULL_COVER: LISTING_EQUIPMENT_TYPE.FULL_COVER,
  SPRAY_HOOD: LISTING_EQUIPMENT_TYPE.SPRAY_HOOD,
  WINTER_COVER: LISTING_EQUIPMENT_TYPE.WINTER_COVER,
};

/* ------------------------- Additional Information ------------------------- */

export const LISTING_ADDITIONAL_INFO_MATERIAL = {
  ALUMINIUM: 'aluminium',
  STEEL: 'steel',
};

export const LISTING_BRANDS = [
  { value: 'BENETEAU', label: 'Beneteau' },
  { value: 'JEANNEAU', label: 'Jeanneau' },
  { value: 'ANDERE', label: 'Andere' },
  { value: 'PRINCESS', label: 'Princess' },
  { value: 'SUNSEEKER', label: 'Sunseeker' },
  { value: 'BAVARIA', label: 'Bavaria' },
  { value: 'CUSTOM', label: 'Custom' },
  { value: 'LAGOON', label: 'Lagoon' },
  { value: 'AZIMUT', label: 'Azimut' },
  { value: 'FAIRLINE', label: 'Fairline' },
  { value: '3C COMPOSITES', label: '3C Composites' },
  { value: '3D CRAFT', label: '3D Craft' },
  { value: '3D TENDER', label: '3D Tender' },
  { value: 'AB', label: 'AB' },
  { value: 'AB INFLATABLES', label: 'AB Inflatables' },
  { value: 'ABD', label: 'ABD' },
  { value: 'ACM', label: 'ACM' },
  { value: 'ALB SAIL', label: 'ALB Sail' },
  { value: 'AMT', label: 'AMT' },
  { value: 'AQUASPIRIT', label: 'AQUASPIRIT' },
  { value: 'ATX SURF BOATS', label: 'ATX Surf Boats' },
  { value: 'ABACUS', label: 'Abacus' },
  { value: 'ABATI YACHTS', label: 'Abati Yachts' },
  { value: 'ABEKING & RASMUSSEN', label: 'Abeking & Rasmussen' },
  { value: 'ABIM', label: 'Abim' },
  { value: 'ABSOLUTE', label: 'Absolute' },
  { value: 'ADA YACHT', label: 'Ada Yacht' },
  { value: 'ADAGIO', label: 'Adagio' },
  { value: 'ADMIRAL', label: 'Admiral' },
  { value: 'ADMIRALSTENDER', label: 'AdmiralsTender' },
  { value: 'ADRIA', label: 'Adria' },
  { value: 'ADVANCED YACHTS', label: 'Advanced Yachts' },
  { value: 'AEGEAN YACHT', label: 'Aegean Yacht' },
  { value: 'AERMARINE', label: 'Aermarine' },
  { value: 'AFRICAN CATS', label: 'African Cats' },
  { value: 'AGANLAR', label: 'Aganlar' },
  { value: 'AGAPI', label: 'Agapi' },
  { value: 'AGDER', label: 'Agder' },
  { value: 'AGENA MARIN', label: 'Agena Marin' },
  { value: 'AGILIS', label: 'Agilis' },
  { value: 'AICON', label: 'Aicon' },
  { value: 'AICON YACHTS', label: 'Aicon Yachts' },
  { value: 'AIRON', label: 'Airon' },
  { value: 'AKERBOOM', label: 'Akerboom' },
  { value: 'ALCUSTOM', label: 'AlCustom' },
  { value: 'ALALUNGA', label: 'Alalunga' },
  { value: 'ALAN PAPE', label: 'Alan Pape' },
  { value: 'ALBATRO', label: 'Albatro' },
  { value: 'ALBATROSS', label: 'Albatross' },
  { value: 'ALBEMARLE', label: 'Albemarle' },
  { value: 'ALBIN', label: 'Albin' },
  { value: 'ALDEN', label: 'Alden' },
  { value: 'ALEN', label: 'Alen' },
  { value: 'ALENA', label: 'Alena' },
  { value: 'ALFAMARINE', label: 'Alfamarine' },
  { value: 'ALFASTREET', label: 'Alfastreet' },
  { value: 'ALIBI', label: 'Alibi' },
  { value: 'ALLIAGE', label: 'Alliage' },
  { value: 'ALLIAURA', label: 'Alliaura' },
  { value: 'ALLOY YACHTS', label: 'Alloy Yachts' },
  { value: 'ALLSEAS', label: 'Allseas' },
  { value: 'ALLURES', label: 'Allures' },
  { value: 'ALM', label: 'Alm' },
  { value: 'ALPA', label: 'Alpa' },
  { value: 'ALPHA', label: 'Alpha' },
  { value: 'ALSON', label: 'Alson' },
  { value: 'ALTAIR', label: 'Altair' },
  { value: 'ALTAMAREA', label: 'Altamarea' },
  { value: 'ALTENA', label: 'Altena' },
  { value: 'ALU MARINE', label: 'Alu Marine' },
  { value: 'ALUBAT', label: 'Alubat' },
  { value: 'ALUMAX', label: 'Alumax' },
  { value: 'ALUMINUM CRUISER', label: 'Aluminum Cruiser' },
  { value: 'ALUVA', label: 'Aluva' },
  { value: 'AMARÈS', label: 'Amarès' },
  { value: 'AMEL', label: 'Amel' },
  { value: 'AMELS', label: 'Amels' },
  { value: 'AMER', label: 'Amer' },
  { value: 'AMERGLASS', label: 'Amerglass' },
  { value: 'AMERICAN MARINE', label: 'American Marine' },
  { value: 'AMERICAN TUG', label: 'American Tug' },
  { value: 'AMIGO', label: 'Amigo' },
  { value: 'ANDAMAN', label: 'Andaman' },
  { value: 'ANDREWS', label: 'Andrews' },
  { value: 'ANDROS', label: 'Andros' },
  { value: 'ANGEL', label: 'Angel' },
  { value: 'ANSTEY YACHTS', label: 'Anstey Yachts' },
  { value: 'ANTAGO', label: 'Antago' },
  { value: 'ANTARIS', label: 'Antaris' },
  { value: 'ANVERA', label: 'Anvera' },
  { value: 'ANYTEC', label: 'Anytec' },
  { value: 'APREAMARE', label: 'Apreamare' },
  { value: 'AQUA', label: 'Aqua' },
  { value: 'AQUA-HOUSE', label: 'Aqua-House' },
  { value: 'AQUABELL', label: 'AquaBell' },
  { value: 'AQUABAT', label: 'Aquabat' },
  { value: 'AQUADOR', label: 'Aquador' },
  { value: 'AQUALINE', label: 'Aqualine' },
  { value: 'AQUAMARINE', label: 'Aquamarine' },
  { value: 'AQUANAUT', label: 'Aquanaut' },
  { value: 'AQUASTAR', label: 'Aquastar' },
  { value: 'AQUATRON', label: 'Aquatron' },
  { value: 'AQUILA', label: 'Aquila' },
  { value: 'AQUITALIA', label: 'Aquitalia' },
  { value: 'ARCADIA YACHTS', label: 'Arcadia Yachts' },
  { value: 'ARCHAMBAULT', label: 'Archambault' },
  { value: 'ARCOA', label: 'Arcoa' },
  { value: 'ARCONA', label: 'Arcona' },
  { value: 'ARCTIC BLUE', label: 'Arctic Blue' },
  { value: 'ARESA', label: 'Aresa' },
  { value: 'ARGOS', label: 'Argos' },
  { value: 'ARIE WIEGMANS', label: 'Arie Wiegmans' },
  { value: 'ARIMAR', label: 'Arimar' },
  { value: 'ARKOS', label: 'Arkos' },
  { value: 'ARKSEN', label: 'Arksen' },
  { value: 'ARMON', label: 'Armon' },
  { value: 'ARNO LEOPARD', label: 'Arno Leopard' },
  { value: 'ARROW BOATS', label: 'Arrow Boats' },
  { value: 'ARTABAN', label: 'Artaban' },
  { value: 'ARVOR', label: 'Arvor' },
  { value: 'ASIS', label: 'Asis' },
  { value: 'ASKELADDEN', label: 'Askeladden' },
  { value: 'ASPRE', label: 'Aspre' },
  { value: 'ASTEC', label: 'Astec' },
  { value: 'ASTERIE', label: 'Asterie' },
  { value: 'ASTILLEROS', label: 'Astilleros' },
  { value: 'ASTINOR', label: 'Astinor' },
  { value: 'ASTON MARTIN', label: 'Aston Martin' },
  { value: 'ASTONDOA', label: 'Astondoa' },
  { value: 'ASTUS', label: 'Astus' },
  { value: 'ATAK YACHTS', label: 'Atak Yachts' },
  { value: 'ATHENA', label: 'Athena' },
  { value: 'ATLANTA', label: 'Atlanta' },
  { value: 'ATLANTIC', label: 'Atlantic' },
  { value: 'ATLANTIS', label: 'Atlantis' },
  { value: 'ATLAS BOAT WORKS', label: 'Atlas Boat Works' },
  { value: 'ATOLLVIC', label: 'Atollvic' },
  { value: 'AUREA', label: 'Aurea' },
  { value: 'AUSTIN PARKER', label: 'Austin Parker' },
  { value: 'AVA YACHTS', label: 'AvA Yachts' },
  { value: 'AVENTURA', label: 'Aventura' },
  { value: 'AVON', label: 'Avon' },
  { value: 'AXEL MARINE', label: 'Axel Marine' },
  { value: 'AXOPAR', label: 'Axopar' },
  { value: 'AYROS', label: 'Ayros' },
  { value: 'AZURE', label: 'Azure' },
  { value: 'AZUREE', label: 'Azuree' },
  { value: 'AZZUM', label: 'Azzum' },
  { value: 'AZZURRO', label: 'Azzurro' },
  { value: 'BB YACHTS', label: 'BB Yachts' },
  { value: 'BMA', label: 'BMA' },
  { value: 'BRABUS', label: 'BRABUS' },
  { value: 'BSC', label: 'BSC' },
  { value: 'BWA', label: 'BWA' },
  { value: 'BAD CATS', label: 'BaD Cats' },
  { value: 'BABA', label: 'Baba' },
  { value: 'BABRO', label: 'Babro' },
  { value: 'BAGLIETTO', label: 'Baglietto' },
  { value: 'BAIA', label: 'Baia' },
  { value: 'BAJA', label: 'Baja' },
  { value: 'BAKDEKKER', label: 'Bakdekker' },
  { value: 'BAKDEKKRUISER', label: 'Bakdekkruiser' },
  { value: 'BALI', label: 'Bali' },
  { value: 'BALT', label: 'Balt' },
  { value: 'BALTIC', label: 'Baltic' },
  { value: 'BANDIDO', label: 'Bandido' },
  { value: 'BANGOR', label: 'Bangor' },
  { value: 'BANI', label: 'Bani' },
  { value: 'BANJER', label: 'Banjer' },
  { value: 'BARATTUCCI', label: 'Barattucci' },
  { value: 'BARBARY', label: 'Barbary' },
  { value: 'BARBERIS', label: 'Barberis' },
  { value: 'BARGE', label: 'Barge' },
  { value: 'BARKAS', label: 'Barkas' },
  { value: 'BARQA', label: 'Barqa' },
  { value: 'BARRACUDA', label: 'Barracuda' },
  { value: 'BAYLINER', label: 'Bayliner' },
  { value: 'BEACHCRAFT', label: 'Beachcraft' },
  { value: 'BEE', label: 'Bee' },
  { value: 'BEEKMAN', label: 'Beekman' },
  { value: 'BEENHAKKER', label: 'Beenhakker' },
  { value: 'BEGE', label: 'Bege' },
  { value: 'BEJA', label: 'Beja' },
  { value: 'BEKEBREDE', label: 'Bekebrede' },
  { value: 'BEKKERS YACHTS', label: 'Bekkers Yachts' },
  { value: 'BELASSI', label: 'Belassi' },
  { value: 'BELLA', label: 'Bella' },
  { value: 'BELLIURE', label: 'Belliure' },
  { value: 'BELLUS', label: 'Bellus' },
  { value: 'BENDIE', label: 'Bendie' },
  { value: 'BENETTI', label: 'Benetti' },
  { value: 'BENETTI SAIL DIVISION', label: 'Benetti Sail Division' },
  { value: 'BENFORD', label: 'Benford' },
  { value: 'BENTE', label: 'Bente' },
  { value: 'BERGUMERMEER', label: 'Bergumermeer' },
  { value: 'BERING', label: 'Bering' },
  { value: 'BERING MARINE', label: 'Bering Marine' },
  { value: 'BERNICO', label: 'Bernico' },
  { value: 'BERTHON', label: 'Berthon' },
  { value: 'BERTRAM', label: 'Bertram' },
  { value: 'BESTEVAER', label: 'Bestevaer' },
  { value: 'BIAM', label: 'Biam' },
  { value: 'BIANCA', label: 'Bianca' },
  { value: 'BIGA', label: 'Biga' },
  { value: 'BILGIN', label: 'Bilgin' },
  { value: 'BIMAX', label: 'Bimax' },
  { value: 'BIRCHWOOD', label: 'Birchwood' },
  { value: 'BIRDYFISH', label: 'BirdyFish' },
  { value: 'BLACK PEPPER', label: 'Black Pepper' },
  { value: 'BLACKFIN', label: 'Blackfin' },
  { value: 'BLAUNDUS', label: 'Blaundus' },
  { value: 'BLAUWE HAND', label: 'Blauwe Hand' },
  { value: 'BLOCK ISLAND', label: 'Block Island' },
  { value: 'BLOEMSMA', label: 'Bloemsma' },
  { value: 'BLOUNT', label: 'Blount' },
  { value: 'BLU MARTIN YACHTS', label: 'Blu Martin Yachts' },
  { value: 'BLUE OCEAN', label: 'Blue Ocean' },
  { value: 'BLUE SPIRIT', label: 'Blue Spirit' },
  { value: 'BLUEGAME', label: 'Bluegame' },
  { value: 'BOARNCRUISER', label: 'Boarncruiser' },
  { value: 'BOATYARD', label: 'Boatyard' },
  { value: 'BOESCH', label: 'Boesch' },
  { value: 'BOLA', label: 'Bola' },
  { value: 'BOLD', label: 'Bold' },
  { value: 'BOLGER', label: 'Bolger' },
  { value: 'BOLIDE', label: 'Bolide' },
  { value: 'BOMBARD', label: 'Bombard' },
  { value: 'BOMBARDIER', label: 'Bombardier' },
  { value: 'BONDWAY', label: 'Bondway' },
  { value: 'BONIN', label: 'Bonin' },
  { value: 'BORRESEN', label: 'Borresen' },
  { value: 'BOSTON WHALER', label: 'Boston Whaler' },
  { value: 'BOSTROM', label: 'Bostrom' },
  { value: 'BOTNIA', label: 'Botnia' },
  { value: 'BOTTER', label: 'Botter' },
  { value: 'BOUDIGNON', label: 'Boudignon' },
  { value: 'BOUNTY', label: 'Bounty' },
  { value: 'BOWMAN', label: 'Bowman' },
  { value: 'BRABANT', label: 'Brabant' },
  { value: 'BRANDARIS', label: 'Brandaris' },
  { value: 'BRANDSMA', label: 'Brandsma' },
  { value: 'BREEDENDAM', label: 'Breedendam' },
  { value: 'BREEHORN', label: 'Breehorn' },
  { value: 'BRENDAN', label: 'Brendan' },
  { value: 'BRIG', label: 'Brig' },
  { value: 'BRITISH HUNTER', label: 'British Hunter' },
  { value: 'BROESDER KOTTER', label: 'Broesder Kotter' },
  { value: 'BROOKE MARINE', label: 'Brooke Marine' },
  { value: 'BROOM', label: 'Broom' },
  { value: 'BROWARD', label: 'Broward' },
  { value: 'BRUCE ROBERTS', label: 'Bruce Roberts' },
  { value: 'BRUIJS', label: 'Bruijs' },
  { value: 'BRUMENT', label: 'Brument' },
  { value: 'BRUNO ABBATE', label: 'Bruno Abbate' },
  { value: 'BRYANT', label: 'Bryant' },
  { value: 'BUCHANAN', label: 'Buchanan' },
  { value: 'BUDDY DAVIS', label: 'Buddy Davis' },
  { value: 'BUGARI', label: 'Bugari' },
  { value: 'BUIZEN', label: 'Buizen' },
  { value: 'BULL', label: 'Bull' },
  { value: 'BURGER', label: 'Burger' },
  { value: 'BUSTER', label: 'Buster' },
  { value: 'BÜTZFLETH', label: 'Bützfleth' },
  { value: 'C & L', label: 'C & L' },
  { value: 'C-CATAMARANS', label: 'C-Catamarans' },
  { value: 'C-TENDER', label: 'C-Tender' },
  { value: 'C-YACHT', label: 'C-Yacht' },
  { value: 'CAL', label: 'CAL' },
  { value: 'CBI', label: 'CBI' },
  { value: 'CCYD', label: 'CCYD' },
  { value: 'CDK TECHNOLOGIES', label: 'CDK Technologies' },
  { value: 'CH MARINE', label: 'CH Marine' },
  { value: 'CHB', label: 'CHB' },
  { value: 'CL YACHTS', label: 'CL Yachts' },
  { value: 'CMB YACHTS', label: 'CMB Yachts' },
  { value: 'CMN', label: 'CMN' },
  { value: 'CNB', label: 'CNB' },
  { value: 'CNC', label: 'CNC' },
  { value: 'CNM', label: 'CNM' },
  { value: 'CNSO', label: 'CNSO' },
  { value: 'CR', label: 'CR' },
  { value: 'CRN', label: 'CRN' },
  { value: 'CT', label: 'CT' },
  { value: 'CABO', label: 'Cabo' },
  { value: 'CAMMENGA', label: 'Cammenga' },
  { value: 'CAMPER & NICHOLSONS', label: 'Camper & Nicholsons' },
  { value: 'CAMPI', label: 'Campi' },
  { value: 'CAMPION', label: 'Campion' },
  { value: 'CAMUFFO', label: 'Camuffo' },
  { value: 'CANADOS', label: 'Canados' },
  { value: 'CANTIERI ESTENSI', label: 'Cantieri Estensi' },
  { value: 'CANTIERI NAVALI LIGURI', label: 'Cantieri Navali Liguri' },
  { value: 'CANTIERI DI PISA', label: 'Cantieri di Pisa' },
  { value: 'CANTIERI DI SARNICO', label: 'Cantieri di Sarnico' },
  { value: 'CAPE CODDER', label: 'Cape Codder' },
  { value: 'CAPE CRUISER', label: 'Cape Cruiser' },
  { value: 'CAPE SCOTT', label: 'Cape Scott' },
  { value: 'CAPELLI', label: 'Capelli' },
  { value: 'CAPOFORTE', label: 'Capoforte' },
  { value: 'CARAVANBOAT', label: 'Caravanboat' },
  { value: 'CARAVELLE', label: 'Caravelle' },
  { value: 'CARGO SHIP', label: 'Cargo Ship' },
  { value: 'CARIBBEAN', label: 'Caribbean' },
  { value: 'CARIBE', label: 'Caribe' },
  { value: 'CARKEEK', label: 'Carkeek' },
  { value: 'CARLINI', label: 'Carlini' },
  { value: 'CARNEVALI', label: 'Carnevali' },
  { value: 'CAROLINA', label: 'Carolina' },
  { value: 'CAROLINA CLASSIC', label: 'Carolina Classic' },
  { value: 'CARTER', label: 'Carter' },
  { value: 'CARVER', label: 'Carver' },
  { value: 'CARY', label: 'Cary' },
  { value: 'CASTAGNOLA', label: 'Castagnola' },
  { value: 'CASTOLDI', label: 'Castoldi' },
  { value: 'CATALINA', label: 'Catalina' },
  { value: 'CATAMARAN', label: 'Catamaran' },
  { value: 'CATAMARAN CRUISERS', label: 'Catamaran Cruisers' },
  { value: 'CATANA', label: 'Catana' },
  { value: 'CATATHAI', label: 'Catathai' },
  { value: 'CATFISH', label: 'Catfish' },
  { value: 'CAYMAN YACHTS', label: 'Cayman Yachts' },
  { value: 'CELEBRITY', label: 'Celebrity' },
  { value: 'CELESTIAL', label: 'Celestial' },
  { value: 'CENTER CONSOLE', label: 'Center Console' },
  { value: 'CENTURION', label: 'Centurion' },
  { value: 'CERRI CANTIERI NAVALI', label: 'Cerri Cantieri Navali' },
  { value: 'CERVERA Y RAMIS', label: 'Cervera y Ramis' },
  { value: 'CERVIGON', label: 'Cervigon' },
  { value: 'CHANTIER DE L’ESTEREL', label: 'Chantier de l’Esterel' },
  { value: 'CHAPARRAL', label: 'Chaparral' },
  { value: 'CHASER', label: 'Chaser' },
  { value: 'CHASSIRON', label: 'Chassiron' },
  { value: 'CHAUDRON', label: 'Chaudron' },
  { value: 'CHEETAH MARINE', label: 'Cheetah Marine' },
  { value: 'CHEOY LEE', label: 'Cheoy Lee' },
  { value: 'CHERUBINI', label: 'Cherubini' },
  { value: 'CHINCOGAN', label: 'Chincogan' },
  { value: 'CHRIS-CRAFT', label: 'Chris-Craft' },
  { value: 'CHRISTENSEN', label: 'Christensen' },
  { value: 'CIGARETTE', label: 'Cigarette' },
  { value: 'CIRCA MARINE', label: 'Circa Marine' },
  { value: 'CLANSMAN', label: 'Clansman' },
  { value: 'CLASS 40', label: 'Class 40' },
  { value: 'CLASSIC', label: 'Classic' },
  { value: 'CLASSIC-YACHTEN', label: 'Classic-Yachten' },
  { value: 'CLEAR', label: 'Clear' },
  { value: 'CLEVER', label: 'Clever' },
  { value: 'CLIPPER MOTOR YACHTS', label: 'Clipper Motor Yachts' },
  { value: 'COANDA', label: 'Coanda' },
  { value: 'COASTAL', label: 'Coastal' },
  { value: 'COBALT', label: 'Cobalt' },
  { value: 'COBRA', label: 'Cobra' },
  { value: 'COBRA RIBS', label: 'Cobra Ribs' },
  { value: 'COBRA YACHTS', label: 'Cobra Yachts' },
  { value: 'COBREY', label: 'Cobrey' },
  { value: 'COCKWELLS', label: 'Cockwells' },
  { value: 'CODECASA', label: 'Codecasa' },
  { value: 'COLIN ARCHER', label: 'Colin Archer' },
  { value: 'COLLINGWOOD', label: 'Collingwood' },
  { value: 'COLOMBO', label: 'Colombo' },
  { value: 'COLUMBIA YACHT', label: 'Columbia Yacht' },
  { value: 'COLVIC', label: 'Colvic' },
  { value: 'COLVIN', label: 'Colvin' },
  { value: 'COLVIN GAZELLE', label: 'Colvin Gazelle' },
  { value: 'COMAR', label: 'Comar' },
  { value: 'COMET', label: 'Comet' },
  { value: 'COMFORTINA', label: 'Comfortina' },
  { value: 'COMITTI', label: 'Comitti' },
  { value: 'COMMERCIAL', label: 'Commercial' },
  { value: 'COMPROMIS', label: 'Compromis' },
  { value: 'CONAM', label: 'Conam' },
  { value: 'CONCORDE', label: 'Concorde' },
  { value: 'CONCORDIA', label: 'Concordia' },
  { value: 'CONDOR', label: 'Condor' },
  { value: 'CONRAD', label: 'Conrad' },
  { value: 'CONTESSA', label: 'Contessa' },
  { value: 'CONTEST', label: 'Contest' },
  { value: 'CONTRAST', label: 'Contrast' },
  { value: 'COOPER', label: 'Cooper' },
  { value: 'COPINO', label: 'Copino' },
  { value: 'CORA', label: 'Cora' },
  { value: 'CORAL', label: 'Coral' },
  { value: 'CORBY', label: 'Corby' },
  { value: 'CORINTHIAN', label: 'Corinthian' },
  { value: 'CORMATE', label: 'Cormate' },
  { value: 'CORNISH CRABBERS', label: 'Cornish Crabbers' },
  { value: 'CORONET', label: 'Coronet' },
  { value: 'CORRECT CRAFT', label: 'Correct Craft' },
  { value: 'CORSAIR', label: 'Corsair' },
  { value: 'CORSIVA', label: 'Corsiva' },
  { value: 'CORVETTE', label: 'Corvette' },
  { value: 'COSTANTINI', label: 'Costantini' },
  { value: 'COUGAR', label: 'Cougar' },
  { value: 'CRANCHI', label: 'Cranchi' },
  { value: 'CREEKMORE', label: 'Creekmore' },
  { value: 'CRESCENT', label: 'Crescent' },
  { value: 'CRESTLINER', label: 'Crestliner' },
  { value: 'CROMPTON MARINE', label: 'Crompton Marine' },
  { value: 'CROWN CRUISER', label: 'Crown Cruiser' },
  { value: 'CROWNLINE', label: 'Crownline' },
  { value: 'CRUISERS', label: 'Cruisers' },
  { value: 'CRUISERS YACHTS', label: 'Cruisers Yachts' },
  { value: 'CUMULANT', label: 'Cumulant' },
  { value: 'CURTEVENNE', label: 'Curtevenne' },
  { value: 'CUSTOM LINE', label: 'Custom Line' },
  { value: 'CYGNUS', label: 'Cygnus' },
  { value: 'CYTRA', label: 'Cytra' },
  { value: 'DNA', label: 'DNA' },
  { value: 'DOCK', label: 'DOCK' },
  { value: 'DAVINCI', label: 'DaVinci' },
  { value: 'DAHL', label: 'Dahl' },
  { value: 'DAKOTA', label: 'Dakota' },
  { value: 'DALE', label: 'Dale' },
  { value: 'DALLA PIETA', label: 'Dalla Pieta' },
  { value: 'DAMARIN', label: 'Damarin' },
  { value: 'DAMEN', label: 'Damen' },
  { value: 'DANIELP1TESTER', label: 'DanielP1Tester' },
  { value: 'DANISH YACHTS', label: 'Danish Yachts' },
  { value: 'DARIEL', label: 'Dariel' },
  { value: 'DAVY & ORSTED', label: 'Davy & Orsted' },
  { value: 'DAYSAILER', label: 'Daysailer' },
  { value: 'DE ANTONIO YACHTS', label: 'De Antonio Yachts' },
  { value: 'DE CESARI', label: 'De Cesari' },
  { value: 'DE GROOT', label: 'De Groot' },
  { value: 'DE RUITER', label: 'De Ruiter' },
  { value: 'DE VRIES LENTSCH', label: 'De Vries Lentsch' },
  { value: 'DEFEVER', label: 'DeFever' },
  { value: 'DEAN', label: 'Dean' },
  { value: 'DEEP WATER YACHTS', label: 'Deep Water Yachts' },
  { value: 'DEFENDER', label: 'Defender' },
  { value: 'DEGERO', label: 'Degero' },
  { value: 'DEHLER', label: 'Dehler' },
  { value: 'DELPHIA', label: 'Delphia' },
  { value: 'DELTA', label: 'Delta' },
  { value: 'DELTA MARINE', label: 'Delta Marine' },
  { value: 'DELTA POWERBOATS', label: 'Delta Powerboats' },
  { value: 'DERECKTOR', label: 'Derecktor' },
  { value: 'DEVONPORT', label: 'Devonport' },
  { value: 'DI DONNA', label: 'Di Donna' },
  { value: 'DIANO', label: 'Diano' },
  { value: 'DINGHY', label: 'Dinghy' },
  { value: 'DIPOL', label: 'Dipol' },
  { value: 'DISCOVERY', label: 'Discovery' },
  { value: 'DIVA', label: 'Diva' },
  { value: 'DIXON', label: 'Dixon' },
  { value: 'DOERAK', label: 'Doerak' },
  { value: 'DOGGERSBANK', label: 'Doggersbank' },
  { value: 'DOMINATOR', label: 'Dominator' },
  { value: 'DONZI', label: 'Donzi' },
  { value: 'DOQUEVE', label: 'Doqueve' },
  { value: 'DORAL', label: 'Doral' },
  { value: 'DORIFF', label: 'Doriff' },
  { value: 'DRACAN', label: 'Dracan' },
  { value: 'DRACO', label: 'Draco' },
  { value: 'DRAGO', label: 'Drago' },
  { value: 'DRAGONFLY', label: 'Dragonfly' },
  { value: 'DRAIT', label: 'Drait' },
  { value: 'DRAMMER', label: 'Drammer' },
  { value: 'DRASCOMBE', label: 'Drascombe' },
  { value: 'DREAMLINE', label: 'Dreamline' },
  { value: 'DROMEAS', label: 'Dromeas' },
  { value: 'DROMOR', label: 'Dromor' },
  { value: 'DUBBEL & JESSE', label: 'Dubbel & Jesse' },
  { value: 'DUFFY', label: 'Duffy' },
  { value: 'DUFOUR', label: 'Dufour' },
  { value: 'DUFOUR CATAMARANS', label: 'Dufour Catamarans' },
  { value: 'DUTCH', label: 'Dutch' },
  { value: 'DUTCH BARGE', label: 'Dutch Barge' },
  { value: 'DUTCH RUNABOUT', label: 'Dutch Runabout' },
  { value: 'DYKSTRA', label: 'Dykstra' },
  { value: 'DYNAMIQ', label: 'Dynamiq' },
  { value: 'DYNAMIQUE', label: 'Dynamique' },
  { value: 'ECLA', label: 'ECLA' },
  { value: 'EMKA', label: 'EMKA' },
  { value: 'ERYD', label: 'ERYD' },
  { value: 'EAGLE', label: 'Eagle' },
  { value: 'EDERSHIP', label: 'Edership' },
  { value: 'EGG HARBOR', label: 'Egg Harbor' },
  { value: 'EINZELBAU', label: 'Einzelbau' },
  { value: 'ELAN', label: 'Elan' },
  { value: 'ELAN POWER', label: 'Elan Power' },
  { value: 'ELEGANCE', label: 'Elegance' },
  { value: 'ELEGANCE YACHTS', label: 'Elegance Yachts' },
  { value: 'ELEVA', label: 'Eleva' },
  { value: 'ELLING', label: 'Elling' },
  { value: 'ELVSTROM', label: 'Elvstrom' },
  { value: 'ELYSIAN', label: 'Elysian' },
  { value: 'ENDURANCE', label: 'Endurance' },
  { value: 'ENKHUIZENSLOEP', label: 'Enkhuizensloep' },
  { value: 'ENTERPRISE MARINE', label: 'Enterprise Marine' },
  { value: 'EOLO', label: 'Eolo' },
  { value: 'ESCAPE', label: 'Escape' },
  { value: 'ESPADON', label: 'Espadon' },
  { value: 'ESSE', label: 'Esse' },
  { value: 'ETAP', label: 'Etap' },
  { value: 'EUROBANKER', label: 'Eurobanker' },
  { value: 'EUROCRAFT', label: 'Eurocraft' },
  { value: 'EUROPA PATROUILLE', label: 'Europa Patrouille' },
  { value: 'EUROSHIP', label: 'Euroship' },
  { value: 'EUROSLOEP', label: 'Eurosloep' },
  { value: 'EUROSPORT', label: 'Eurosport' },
  { value: 'EVADNE', label: 'Evadne' },
  { value: 'EVENS', label: 'Evens' },
  { value: 'EVERGLADES', label: 'Everglades' },
  { value: 'EVO MARINE', label: 'Evo Marine' },
  { value: 'EVO YACHTS', label: 'Evo Yachts' },
  { value: 'EXCEL', label: 'Excel' },
  { value: 'EXCELLENT', label: 'Excellent' },
  { value: 'EXCESS', label: 'Excess' },
  { value: 'EXPEDITION', label: 'Expedition' },
  { value: 'EXPLORER', label: 'Explorer' },
  { value: 'EXPLORER MOTOR YACHTS', label: 'Explorer Motor Yachts' },
  { value: 'EXTRA', label: 'Extra' },
  { value: 'EXTREME BOATS', label: 'Extreme Boats' },
  { value: 'FB DESIGN', label: 'FB Design' },
  { value: 'FIM', label: 'FIM' },
  { value: 'FS', label: 'FS' },
  { value: 'FX YACHTS', label: 'FX Yachts' },
  { value: 'FABBRO', label: 'Fabbro' },
  { value: 'FACTORIA NAVAL DE MARIN', label: 'Factoria Naval de Marin' },
  { value: 'FAETON', label: 'Faeton' },
  { value: 'FAIREY', label: 'Fairey' },
  { value: 'FAIRLIE', label: 'Fairlie' },
  { value: 'FAIRWAYS MARINE', label: 'Fairways Marine' },
  { value: 'FALCON', label: 'Falcon' },
  { value: 'FANALE MARINE', label: 'Fanale Marine' },
  { value: 'FANTASI', label: 'Fantasi' },
  { value: 'FANTASY', label: 'Fantasy' },
  { value: 'FAREAST', label: 'FarEast' },
  { value: 'FARR', label: 'Farr' },
  { value: 'FASHION', label: 'Fashion' },
  { value: 'FASSMER', label: 'Fassmer' },
  { value: 'FAURBY', label: 'Faurby' },
  { value: 'FEADSHIP', label: 'Feadship' },
  { value: 'FEELING', label: 'Feeling' },
  { value: 'FELCI', label: 'Felci' },
  { value: 'FELCO', label: 'Felco' },
  { value: 'FELLOWSHIP', label: 'Fellowship' },
  { value: 'FELTZ', label: 'Feltz' },
  { value: 'FERRETTI YACHTS', label: 'Ferretti Yachts' },
  { value: 'FIART', label: 'Fiart' },
  { value: 'FIBERLINE', label: 'FiberLine' },
  { value: 'FIBRAFORT', label: 'Fibrafort' },
  { value: 'FIBRESPORT', label: 'Fibresport' },
  { value: 'FILIPPETTI', label: 'Filippetti' },
  { value: 'FINELINER', label: 'Fineliner' },
  { value: 'FINNGULF', label: 'Finngulf' },
  { value: 'FINNMASTER', label: 'Finnmaster' },
  { value: 'FINNYACHT', label: 'Finnyacht' },
  { value: 'FINOT', label: 'Finot' },
  { value: 'FISHER', label: 'Fisher' },
  { value: 'FISKARS', label: 'Fiskars' },
  { value: 'FITZROY YACHTS', label: 'Fitzroy yachts' },
  { value: 'FJORD', label: 'Fjord' },
  { value: 'FLEMING', label: 'Fleming' },
  { value: 'FLETCHER', label: 'Fletcher' },
  { value: 'FLEUR DE LYS', label: 'Fleur de Lys' },
  { value: 'FLEXBOAT', label: 'Flexboat' },
  { value: 'FLIPPER', label: 'Flipper' },
  { value: 'FLYNT', label: 'Flynt' },
  { value: 'FOCUS', label: 'Focus' },
  { value: 'FOLKBOAT', label: 'Folkboat' },
  { value: 'FORBINA', label: 'Forbina' },
  { value: 'FORGUS', label: 'Forgus' },
  { value: 'FORMOSA', label: 'Formosa' },
  { value: 'FORMULA', label: 'Formula' },
  { value: 'FORTUNA', label: 'Fortuna' },
  { value: 'FOST', label: 'Fost' },
  { value: 'FOUNTAIN', label: 'Fountain' },
  { value: 'FOUNTAINE PAJOT', label: 'Fountaine Pajot' },
  { value: 'FOUR', label: 'Four' },
  { value: 'FOUR WINNS', label: 'Four Winns' },
  { value: 'FRANCES', label: 'Frances' },
  { value: 'FRANCHINI', label: 'Franchini' },
  { value: 'FRANCK ROY', label: 'Franck Roy' },
  { value: 'FRANS MAAS', label: 'Frans Maas' },
  { value: 'FRATELLI APREA', label: 'Fratelli Aprea' },
  { value: 'FRAUSCHER', label: 'Frauscher' },
  { value: 'FRED SHEPHERD', label: 'Fred Shepherd' },
  { value: 'FREEDOM', label: 'Freedom' },
  { value: 'FREEMAN', label: 'Freeman' },
  { value: 'FRERS', label: 'Frers' },
  { value: 'FREYA', label: 'Freya' },
  { value: 'FRIENDSHIP', label: 'Friendship' },
  { value: 'FUGU', label: 'Fugu' },
  { value: 'FUN YAK', label: 'Fun Yak' },
  { value: 'FUNCRAFT', label: 'Funcraft' },
  { value: 'FURIA', label: 'Furia' },
  { value: 'FUTURA', label: 'Futura' },
  { value: 'FUTURO BOATS', label: 'Futuro Boats' },
  { value: 'G-TENDER', label: 'G-Tender' },
  { value: 'GHI YACHTS', label: 'GHI Yachts' },
  { value: 'GS', label: 'GS' },
  { value: 'GAGLIOTTA', label: 'Gagliotta' },
  { value: 'GALA', label: 'Gala' },
  { value: 'GALEON', label: 'Galeon' },
  { value: 'GALIA', label: 'Galia' },
  { value: 'GANLEY', label: 'Ganley' },
  { value: 'GANNON & BENJAMIN', label: 'Gannon & Benjamin' },
  { value: 'GARCIA', label: 'Garcia' },
  { value: 'GARIMAR', label: 'Garimar' },
  { value: 'GARIN', label: 'Garin' },
  { value: 'GEMINI', label: 'Gemini' },
  { value: 'GENERAL BOATS', label: 'General Boats' },
  { value: 'GENESIS', label: 'Genesis' },
  { value: 'GENESIS YACHTS', label: 'Genesis Yachts' },
  { value: 'GHIBLI', label: 'Ghibli' },
  { value: 'GIANETTI', label: 'Gianetti' },
  { value: 'GIB SEA', label: "Gib'Sea" },
  { value: 'GIEFFE', label: 'Gieffe' },
  { value: 'GILLISSEN', label: 'Gillissen' },
  { value: 'GIORGI', label: 'Giorgi' },
  { value: 'GIRBAU', label: 'Girbau' },
  { value: 'GLACER', label: 'Glacer' },
  { value: 'GLACIER', label: 'Glacier' },
  { value: 'GLASSPORT', label: 'Glassport' },
  { value: 'GLASTRON', label: 'Glastron' },
  { value: 'GOBBI', label: 'Gobbi' },
  { value: 'GOETZ', label: 'Goetz' },
  { value: 'GOLDEN HIND', label: 'Golden Hind' },
  { value: 'GOLDFISH', label: 'Goldfish' },
  { value: 'GOSPEL BOAT', label: 'Gospel Boat' },
  { value: 'GOZZO', label: 'Gozzo' },
  { value: 'GRADY-WHITE', label: 'Grady-White' },
  { value: 'GRAMPIAN', label: 'Grampian' },
  { value: 'GRAND', label: 'Grand' },
  { value: 'GRAND BANKS', label: 'Grand Banks' },
  { value: 'GRAND CRAFT', label: 'Grand Craft' },
  { value: 'GRAND INFLATABLES', label: 'Grand Inflatables' },
  { value: 'GRAND SOLEIL', label: 'Grand Soleil' },
  { value: 'GRANDEZZA', label: 'Grandezza' },
  { value: 'GRAUNNER', label: 'Graunner' },
  { value: 'GREEN MARINE', label: 'Green Marine' },
  { value: 'GREENLINE', label: 'Greenline' },
  { value: 'GREW', label: 'Grew' },
  { value: 'GROUWSTER VLET', label: 'Grouwster Vlet' },
  { value: 'GRUNO', label: 'Gruno' },
  { value: 'GRUPPO MARE', label: 'Gruppo Mare' },
  { value: 'GULET', label: 'Gulet' },
  { value: 'GULF CRAFT', label: 'Gulf Craft' },
  { value: 'GULFSTAR', label: 'Gulfstar' },
  { value: 'GUNBOAT', label: 'Gunboat' },
  { value: 'GUNFLEET', label: 'Gunfleet' },
  { value: 'GUY COUACH', label: 'Guy Couach' },
  { value: 'GUYMARINE', label: 'Guymarine' },
  { value: 'HCB', label: 'HCB' },
  { value: 'HH CATAMARANS', label: 'HH Catamarans' },
  { value: 'HM POWERBOATS', label: 'HM Powerboats' },
  { value: 'HOC', label: 'HOC' },
  { value: 'HABER', label: 'Haber' },
  { value: 'HACKER-CRAFT', label: 'Hacker-Craft' },
  { value: 'HAINES', label: 'Haines' },
  { value: 'HAKE / SEAWARD', label: 'Hake / Seaward' },
  { value: 'HAKVOORT', label: 'Hakvoort' },
  { value: 'HALLBERG-RASSY', label: 'Hallberg-Rassy' },
  { value: 'HALMATIC', label: 'Halmatic' },
  { value: 'HALTER', label: 'Halter' },
  { value: 'HALVORSEN', label: 'Halvorsen' },
  { value: 'HAMPTON', label: 'Hampton' },
  { value: 'HANS CHRISTIAN', label: 'Hans Christian' },
  { value: 'HANSE', label: 'Hanse' },
  { value: 'HANSEAT', label: 'Hanseat' },
  { value: 'HARDING', label: 'Harding' },
  { value: 'HARDY', label: 'Hardy' },
  { value: 'HARLAND AND WOLFF', label: 'Harland and Wolff' },
  { value: 'HARMONY', label: 'Harmony' },
  { value: 'HARRISON BUTLER', label: 'Harrison Butler' },
  { value: 'HARTLEY', label: 'Hartley' },
  { value: 'HASCRAFT', label: 'HasCraft' },
  { value: 'HATTERAS', label: 'Hatteras' },
  { value: 'HAVENLODGE', label: 'Havenlodge' },
  { value: 'HEESEN', label: 'Heesen' },
  { value: 'HELLEMAN', label: 'Helleman' },
  { value: 'HELLINGSKIP', label: 'Hellingskip' },
  { value: 'HELLWIG', label: 'Hellwig' },
  { value: 'HELMSMAN', label: 'Helmsman' },
  { value: 'HEMMES', label: 'Hemmes' },
  { value: 'HERBULOT', label: 'Herbulot' },
  { value: 'HERON', label: 'Heron' },
  { value: 'HERRESHOFF', label: 'Herreshoff' },
  { value: 'HERSHINE', label: 'Hershine' },
  { value: 'HI-STAR', label: 'Hi-Star' },
  { value: 'HIGHFIELD', label: 'Highfield' },
  { value: 'HINCKLEY', label: 'Hinckley' },
  { value: 'HISTORIC', label: 'Historic' },
  { value: 'HODGDON', label: 'Hodgdon' },
  { value: 'HOEK', label: 'Hoek' },
  { value: 'HOLLAND', label: 'Holland' },
  { value: 'HOLLAND JACHTBOUW', label: 'Holland Jachtbouw' },
  { value: 'HOLLANDIA', label: 'Hollandia' },
  { value: 'HOLMAN & PYE', label: 'Holman & Pye' },
  { value: 'HOLTERMAN', label: 'Holterman' },
  { value: 'HOOVELD', label: 'Hooveld' },
  { value: 'HORIZON', label: 'Horizon' },
  { value: 'HOUSEBOAT', label: 'Houseboat' },
  { value: 'HUISMAN', label: 'Huisman' },
  { value: 'HUITEMA', label: 'Huitema' },
  { value: 'HUMBER', label: 'Humber' },
  { value: 'HUMPHREYS', label: 'Humphreys' },
  { value: 'HUNT YACHTS', label: 'Hunt Yachts' },
  { value: 'HUNTER', label: 'Hunter' },
  { value: 'HUNTON', label: 'Hunton' },
  { value: 'HURLEY', label: 'Hurley' },
  { value: 'HUSTLER', label: 'Hustler' },
  { value: 'HUTTING', label: 'Hutting' },
  { value: 'HYDRA-SPORTS', label: 'Hydra-Sports' },
  { value: 'HYDROLIFT', label: 'Hydrolift' },
  { value: 'HYDROSPORT', label: 'Hydrosport' },
  { value: 'HYLAS', label: 'Hylas' },
  { value: 'ILIAD', label: 'ILIAD' },
  { value: 'ISA', label: 'ISA' },
  { value: 'IBERICA', label: 'Iberica' },
  { value: 'ICE YACHTS', label: 'Ice Yachts' },
  { value: 'IDEA', label: 'Idea' },
  { value: 'IGUANA', label: 'Iguana' },
  { value: 'IJLSTERVLET', label: 'Ijlstervlet' },
  { value: 'ILVER', label: 'Ilver' },
  { value: 'IMEXUS', label: 'Imexus' },
  { value: 'INACE', label: 'Inace' },
  { value: 'INFINITI', label: 'Infiniti' },
  { value: 'INFLATABLE', label: 'Inflatable' },
  { value: 'INNOVAZIONE E PROGETTI', label: 'Innovazione e Progetti' },
  { value: 'INTERBOAT', label: 'Interboat' },
  { value: 'INTERCRUISER', label: 'Intercruiser' },
  { value: 'INTERMARE', label: 'Intermare' },
  { value: 'INTERMARINE', label: 'Intermarine' },
  { value: 'INTERNATIONAL', label: 'International' },
  { value: 'INTREPID', label: 'Intrepid' },
  { value: 'INVICTUS', label: 'Invictus' },
  { value: 'INVINCIBLE', label: 'Invincible' },
  { value: 'IRON', label: 'Iron' },
  { value: 'ISLAND GYPSY', label: 'Island Gypsy' },
  { value: 'ISLAND HOPPER', label: 'Island Hopper' },
  { value: 'ISLAND PACKET', label: 'Island Packet' },
  { value: 'ISLAND PLASTICS', label: 'Island Plastics' },
  { value: 'ISLAND TRADER', label: 'Island Trader' },
  { value: 'ISLOEP', label: 'Isloep' },
  { value: 'ITALBOATS', label: 'Italboats' },
  { value: 'ITALCRAFT', label: 'Italcraft' },
  { value: 'ITALIA YACHTS', label: 'Italia Yachts' },
  { value: 'ITALVERSIL', label: 'Italversil' },
  { value: 'ITALYACHTS', label: 'Italyachts' },
  { value: 'ITALYURE', label: 'Italyure' },
  { value: 'ITAMA', label: 'Itama' },
  { value: 'J BOATS', label: 'J Boats' },
  { value: 'J CRAFT', label: 'J Craft' },
  { value: 'J-COMPOSITES', label: 'J-Composites' },
  { value: 'JFA YACHTS', label: 'JFA Yachts' },
  { value: 'JPK', label: 'JPK' },
  { value: 'JACABO', label: 'Jacabo' },
  { value: 'JACHTWERF HEEG', label: 'Jachtwerf Heeg' },
  { value: 'JADE', label: 'Jade' },
  { value: 'JAGUAR', label: 'Jaguar' },
  { value: 'JAN VAN GENT', label: 'Jan Van Gent' },
  { value: 'JANTAR', label: 'Jantar' },
  { value: 'JEANTOT', label: 'Jeantot' },
  { value: 'JEFFERSON', label: 'Jefferson' },
  { value: 'JERSEY', label: 'Jersey' },
  { value: 'JET TENDER', label: 'Jet Tender' },
  { value: 'JETCRAFT', label: 'Jetcraft' },
  { value: 'JETTEN', label: 'Jetten' },
  { value: 'JIANGLONG', label: 'Jianglong' },
  { value: 'JODA', label: 'Joda' },
  { value: 'JOHNSON', label: 'Johnson' },
  { value: 'JOKER', label: 'Joker' },
  { value: 'JOKER BOAT', label: 'Joker Boat' },
  { value: 'JONES-GOODELL', label: 'Jones-Goodell' },
  { value: 'JONGERT', label: 'Jongert' },
  { value: 'JONMERI', label: 'Jonmeri' },
  { value: 'JOSHUA', label: 'Joshua' },
  { value: 'JOUBERT', label: 'Joubert' },
  { value: 'JOUBERT-NIVELT', label: 'Joubert-Nivelt' },
  { value: 'JOUET', label: 'Jouet' },
  { value: 'JUDEL AND VROLIJK', label: 'Judel and Vrolijk' },
  { value: 'JUPITER', label: 'Jupiter' },
  { value: 'KM YACHTBUILDERS', label: 'KM Yachtbuilders' },
  { value: 'KMV', label: 'KMV' },
  { value: 'KAAGKRUISER', label: 'Kaagkruiser' },
  { value: 'KAJUITSLOEP', label: 'Kajuitsloep' },
  { value: 'KAREL', label: 'Karel' },
  { value: 'KARNIC', label: 'Karnic' },
  { value: 'KAUFMAN', label: 'Kaufman' },
  { value: 'KAWASAKI', label: 'Kawasaki' },
  { value: 'KEIZER', label: 'Keizer' },
  { value: 'KELSALL', label: 'Kelsall' },
  { value: 'KELT', label: 'Kelt' },
  { value: 'KEMPALA', label: 'Kempala' },
  { value: 'KEMPERS', label: 'Kempers' },
  { value: 'KER', label: 'Ker' },
  { value: 'KETCH', label: 'Ketch' },
  { value: 'KEY WEST', label: 'Key West' },
  { value: 'KHA SHING', label: 'Kha Shing' },
  { value: 'KING', label: 'King' },
  { value: 'KING MARINE', label: 'King Marine' },
  { value: 'KINGFISHER', label: 'KingFisher' },
  { value: 'KIRIE', label: 'Kirie' },
  { value: 'KLAASSEN', label: 'Klaassen' },
  { value: 'KNIERIM', label: 'Knierim' },
  { value: 'KNIGHT & CARVER', label: 'Knight & Carver' },
  { value: 'KNOBBE', label: 'Knobbe' },
  { value: 'KOK', label: 'Kok' },
  { value: 'KOLIBRI', label: 'Kolibri' },
  { value: 'KOMPIER', label: 'Kompier' },
  { value: 'KONG & HALVORSEN', label: 'Kong & Halvorsen' },
  { value: 'KOOPMANS', label: 'Koopmans' },
  { value: 'KOTTER', label: 'Kotter' },
  { value: 'KRAKEN', label: 'Kraken' },
  { value: 'KRAL', label: 'Kral' },
  { value: 'KRUISER', label: 'Kruiser' },
  { value: 'KUIPERS WOUDSEND', label: 'Kuipers Woudsend' },
  { value: 'KUSTER', label: 'Kuster' },
  { value: 'LM', label: 'LM' },
  { value: 'LADENSTEIN', label: 'Ladenstein' },
  { value: 'LAGO AMORE', label: 'Lago Amore' },
  { value: 'LAGOON ROYAL', label: 'Lagoon Royal' },
  { value: 'LANGENBERG', label: 'Langenberg' },
  { value: 'LANGWEERDER SLOEP', label: 'Langweerder Sloep' },
  { value: 'LARSEN', label: 'Larsen' },
  { value: 'LARSON', label: 'Larson' },
  { value: 'LASAI', label: 'Lasai' },
  { value: 'LASER', label: 'Laser' },
  { value: 'LATINI MARINE', label: 'Latini Marine' },
  { value: 'LATITUDE 46', label: 'Latitude 46' },
  { value: 'LAURENT GILES', label: 'Laurent Giles' },
  { value: 'LAVAGNA', label: 'Lavagna' },
  { value: 'LAVRANOS', label: 'Lavranos' },
  { value: 'LAZZARA', label: 'Lazzara' },
  { value: 'LE BOAT', label: 'Le Boat' },
  { value: 'LECOMTE', label: 'LeComte' },
  { value: 'LEGUEN HEMIDY', label: 'Leguen Hemidy' },
  { value: 'LEISURE', label: 'Leisure' },
  { value: 'LEKKER', label: 'Lekker' },
  { value: 'LEMA', label: 'Lema' },
  { value: 'LEMSTERAAK', label: 'Lemsteraak' },
  { value: 'LEONARD', label: 'Leonard' },
  { value: 'LEOPARD', label: 'Leopard' },
  { value: 'LEROUGE', label: 'Lerouge' },
  { value: 'LEVI', label: 'Levi' },
  { value: 'LIANYA', label: 'Lianya' },
  { value: 'LIBERATOR', label: 'Liberator' },
  { value: 'LIBERTY', label: 'Liberty' },
  { value: 'LIFESTYLE', label: 'Lifestyle' },
  { value: 'LIGHTWAVE', label: 'Lightwave' },
  { value: 'LILYBAEUM', label: 'Lilybaeum' },
  { value: 'LIMITED EDITION', label: 'Limited Edition' },
  { value: 'LINDEN', label: 'Linden' },
  { value: 'LINDER', label: 'Linder' },
  { value: 'LINJETT', label: 'Linjett' },
  { value: 'LINSKENS', label: 'Linskens' },
  { value: 'LINSSEN', label: 'Linssen' },
  { value: 'LION', label: 'Lion' },
  { value: 'LLAUT', label: 'Llaut' },
  { value: 'LOCHIN', label: 'Lochin' },
  { value: 'LOLIVUL', label: 'Lolivul' },
  { value: 'LOMAC', label: 'Lomac' },
  { value: 'LONG ISLAND', label: 'Long Island' },
  { value: 'LOWLAND', label: 'Lowland' },
  { value: 'LUETJE', label: 'Luetje' },
  { value: 'LUFFE', label: 'Luffe' },
  { value: 'LUHRS', label: 'Luhrs' },
  { value: 'LUNA', label: 'Luna' },
  { value: 'LURSSEN', label: 'Lurssen' },
  { value: 'LUXE-MOTOR', label: 'Luxe-Motor' },
  { value: 'LUXIA', label: 'Luxia' },
  { value: 'LYMAN-MORSE', label: 'Lyman-Morse' },
  { value: 'M BOATS', label: 'M Boats' },
  { value: 'M.A.T.', label: 'M.A.T.' },
  { value: 'MOTORYACHTS', label: 'Motoryachts' },
  { value: 'MAC', label: 'MAC' },
  { value: 'MG', label: 'MG' },
  { value: 'MV MARINE', label: 'MV Marine' },
  { value: 'MADERA RIBS', label: 'Madera RIBs' },
  { value: 'MAESTRO', label: 'Maestro' },
  { value: 'MAGAZZU', label: 'Magazzu' },
  { value: 'MAGIC YACHTS', label: 'Magic Yachts' },
  { value: 'MAGNUM', label: 'Magnum' },
  { value: 'MAINSHIP', label: 'Mainship' },
  { value: 'MAIORA', label: 'Maiora' },
  { value: 'MAJESTY', label: 'Majesty' },
  { value: 'MAJONI', label: 'Majoni' },
  { value: 'MAKMA', label: 'Makma' },
  { value: 'MAKO', label: 'Mako' },
  { value: 'MALIBU', label: 'Malibu' },
  { value: 'MALLARD', label: 'Mallard' },
  { value: 'MALO', label: 'Malo' },
  { value: 'MANDAYACHTS', label: 'MandaYachts' },
  { value: 'MANGUSTA', label: 'Mangusta' },
  { value: 'MANO', label: 'Mano' },
  { value: 'MANO MARINE', label: 'Mano Marine' },
  { value: 'MANTA', label: 'Manta' },
  { value: 'MAO TA', label: 'Mao Ta' },
  { value: 'MAORI', label: 'Maori' },
  { value: 'MARC LOMBARD', label: 'Marc Lombard' },
  { value: 'MARCELO PENNA', label: 'Marcelo Penna' },
  { value: 'MARCO', label: 'Marco' },
  { value: 'MAREE HAUTE', label: 'Maree Haute' },
  { value: 'MARELL', label: 'Marell' },
  { value: 'MAREX', label: 'Marex' },
  { value: 'MARHEN', label: 'Marhen' },
  { value: 'MARIAH', label: 'Mariah' },
  { value: 'MARIAN', label: 'Marian' },
  { value: 'MARIEHOLM', label: 'Marieholm' },
  { value: 'MARIL', label: 'Maril' },
  { value: 'MARINE', label: 'Marine' },
  { value: 'MARINE PROJECTS', label: 'Marine Projects' },
  { value: 'MARINE TIME', label: 'Marine Time' },
  { value: 'MARINELLO', label: 'Marinello' },
  { value: 'MARINER', label: 'Mariner' },
  { value: 'MARINO', label: 'Marino' },
  { value: 'MARITIMO', label: 'Maritimo' },
  { value: 'MARLIN', label: 'Marlin' },
  { value: 'MARLOW', label: 'Marlow' },
  { value: 'MARQUIS', label: 'Marquis' },
  { value: 'MARSAUDON COMPOSITES', label: 'Marsaudon Composites' },
  { value: 'MARSHALL', label: 'Marshall' },
  { value: 'MARTEN', label: 'Marten' },
  { value: 'MAS', label: 'Mas' },
  { value: 'MASON', label: 'Mason' },
  { value: 'MASTER', label: 'Master' },
  { value: 'MASTER MARINE INC', label: 'Master Marine Inc' },
  { value: 'MASTERCRAFT', label: 'MasterCraft' },
  { value: 'MAXI', label: 'Maxi' },
  { value: 'MAXI DOLPHIN', label: 'Maxi Dolphin' },
  { value: 'MAXIM YACHTS', label: 'Maxim Yachts' },
  { value: 'MAXIMA', label: 'Maxima' },
  { value: 'MAXUM', label: 'Maxum' },
  { value: 'MAZARIN', label: 'Mazarin' },
  { value: 'MAZU YACHTS', label: 'Mazu Yachts' },
  { value: 'MAZURIA', label: 'Mazuria' },
  { value: 'MCCONAGHY', label: 'McConaghy' },
  { value: 'MCGRUER', label: 'McGruer' },
  { value: 'MEDYACHT', label: 'MedYacht' },
  { value: 'MELGES', label: 'Melges' },
  { value: 'MENGI YAY', label: 'Mengi Yay' },
  { value: 'MENKEN', label: 'Menken' },
  { value: 'MENORQUIN', label: 'Menorquin' },
  { value: 'MERCAN', label: 'Mercan' },
  { value: 'MERCURY', label: 'Mercury' },
  { value: 'MERIDIAN', label: 'Meridian' },
  { value: 'MERY NAUTIC', label: 'Mery Nautic' },
  { value: 'META', label: 'Meta' },
  { value: 'MEYERS', label: 'Meyers' },
  { value: 'MIDGET', label: 'Midget' },
  { value: 'MIDSHIP MARINE', label: 'Midship Marine' },
  { value: 'MIG', label: 'Mig' },
  { value: 'MIKADO', label: 'Mikado' },
  { value: 'MILLENNIUM SUPER YACHTS', label: 'Millennium Super Yachts' },
  { value: 'MILLS', label: 'Mills' },
  { value: 'MIMI', label: 'Mimi' },
  { value: 'MINGOLLA', label: 'Mingolla' },
  { value: 'MINI TRANSAT', label: 'Mini Transat' },
  { value: 'MINOR', label: 'Minor' },
  { value: 'MIRA', label: 'Mira' },
  { value: 'MIRAGE', label: 'Mirage' },
  { value: 'MITCHELL', label: 'Mitchell' },
  { value: 'MOANA', label: 'Moana' },
  { value: 'MOCHI', label: 'Mochi' },
  { value: 'MOCHI CRAFT', label: 'Mochi Craft' },
  { value: 'MOEN', label: 'Moen' },
  { value: 'MOLENKRUISER', label: 'Molenkruiser' },
  { value: 'MONACHUS', label: 'Monachus' },
  { value: 'MONDOMARINE', label: 'Mondomarine' },
  { value: 'MONTE CARLO', label: 'Monte Carlo' },
  { value: 'MONTE CARLO YACHTS', label: 'Monte Carlo Yachts' },
  { value: 'MONTE FINO', label: 'Monte Fino' },
  { value: 'MONTEREY', label: 'Monterey' },
  { value: 'MOODY', label: 'Moody' },
  { value: 'MOON', label: 'Moon' },
  { value: 'MOONDAY', label: 'Moonday' },
  { value: 'MOONEN', label: 'Moonen' },
  { value: 'MOORINGS', label: 'Moorings' },
  { value: 'MORE', label: 'More' },
  { value: 'MORGAN', label: 'Morgan' },
  { value: 'MOSCHINI & MOSTES', label: 'Moschini & Mostes' },
  { value: 'MOSTES', label: 'Mostes' },
  { value: 'MOTIVA', label: 'Motiva' },
  { value: 'MOTOR YACHT', label: 'Motor Yacht' },
  { value: 'MOTORSAILER', label: 'Motorsailer' },
  { value: 'MULDER', label: 'Mulder' },
  { value: 'MULTIPLAST', label: 'Multiplast' },
  { value: 'MULTIVLET', label: 'Multivlet' },
  { value: 'MURAL YACHTS', label: 'Mural Yachts' },
  { value: 'MYABCA', label: 'Myabca' },
  { value: 'MYLIUS', label: 'Mylius' },
  { value: 'MYSTERE', label: 'Mystere' },
  { value: 'MYSTIC', label: 'Mystic' },
  { value: 'NFUN', label: "N'Fun" },
  { value: 'NAB', label: 'NAB' },
  { value: 'NEEL', label: 'NEEL' },
  { value: 'NQEA', label: 'NQEA' },
  { value: 'NACRA', label: 'Nacra' },
  { value: 'NAJAD', label: 'Najad' },
  { value: 'NAJADE', label: 'Najade' },
  { value: 'NANNI', label: 'Nanni' },
  { value: 'NASSIMA YACHT', label: 'Nassima Yacht' },
  { value: 'NAUTIC', label: 'Nautic' },
  { value: 'NAUTICA', label: 'Nautica' },
  { value: 'NAUTICA ESPOSITO', label: 'Nautica Esposito' },
  { value: 'NAUTICA LED', label: 'Nautica LED' },
  { value: 'NAUTICAT', label: 'Nauticat' },
  { value: 'NAUTIPOL', label: 'Nautipol' },
  { value: 'NAUTIQUE', label: 'Nautique' },
  { value: 'NAUTITECH', label: 'Nautitech' },
  { value: 'NAUTOR SWAN', label: 'Nautor Swan' },
  { value: 'NAVAL YACHTS', label: 'Naval Yachts' },
  { value: 'NAVALIA', label: 'Navalia' },
  { value: 'NAVAN', label: 'Navan' },
  { value: 'NAVIGATOR', label: 'Navigator' },
  { value: 'NAVY', label: 'Navy' },
  { value: 'NELSON', label: 'Nelson' },
  { value: 'NEPTUN', label: 'Neptun' },
  { value: 'NEPTUNE', label: 'Neptune' },
  { value: 'NEPTUNUS', label: 'Neptunus' },
  { value: 'NEREA YACHT', label: 'Nerea Yacht' },
  { value: 'NETA MARINE', label: 'Neta Marine' },
  { value: 'NEW CLASSIC', label: 'New Classic' },
  { value: 'NEW OCEAN YACHTS', label: 'New Ocean Yachts' },
  { value: 'NEWCASTLE', label: 'Newcastle' },
  { value: 'NICHOLSON', label: 'Nicholson' },
  { value: 'NICOLS', label: 'Nicols' },
  { value: 'NIDELV', label: 'Nidelv' },
  { value: 'NIKHEN', label: 'Nikhen' },
  { value: 'NIMARINE', label: 'Nimarine' },
  { value: 'NIMBLE', label: 'Nimble' },
  { value: 'NIMBUS', label: 'Nimbus' },
  { value: 'NISSEN', label: 'Nissen' },
  { value: 'NOLIMITS', label: 'Nolimits' },
  { value: 'NOMADREAM', label: 'Nomadream' },
  { value: 'NOORDKAPER', label: 'Noordkaper' },
  { value: 'NOR-TECH', label: 'Nor-Tech' },
  { value: 'NORAY', label: 'Noray' },
  { value: 'NORD STAR', label: 'Nord Star' },
  { value: 'NORD WEST', label: 'Nord West' },
  { value: 'NORDHAVN', label: 'Nordhavn' },
  { value: 'NORDIA', label: 'Nordia' },
  { value: 'NORDIC', label: 'Nordic' },
  { value: 'NORDIC BOATS', label: 'Nordic Boats' },
  { value: 'NORDIC OCEAN CRAFT', label: 'Nordic Ocean Craft' },
  { value: 'NORDIC TUG', label: 'Nordic Tug' },
  { value: 'NORDKAPP', label: 'Nordkapp' },
  { value: 'NORDSHIP', label: 'Nordship' },
  { value: 'NORFEU', label: 'Norfeu' },
  { value: 'NORFOLK', label: 'Norfolk' },
  { value: 'NORLIN', label: 'Norlin' },
  { value: 'NORSEMAN', label: 'Norseman' },
  { value: 'NORTH WIND', label: 'North Wind' },
  { value: 'NORTH-LINE', label: 'North-Line' },
  { value: 'NORTHMAN', label: 'Northman' },
  { value: 'NORTHMASTER', label: 'Northmaster' },
  { value: 'NORTHSTAR', label: 'Northstar' },
  { value: 'NOVA TRAWLER', label: 'Nova Trawler' },
  { value: 'NOVAMARINE', label: 'Novamarine' },
  { value: 'NOVATEC', label: 'Novatec' },
  { value: 'NOVURANIA', label: 'Novurania' },
  { value: 'NOWEE', label: 'Nowee' },
  { value: 'NUMARINE', label: 'Numarine' },
  { value: 'NUOVA JOLLY', label: 'Nuova Jolly' },
  { value: 'NUVA', label: 'Nuva' },
  { value: 'O DAY', label: "O'Day" },
  { value: 'OKEAN', label: 'OKEAN' },
  { value: 'ONJ', label: 'ONJ' },
  { value: 'OCEA', label: 'Ocea' },
  { value: 'OCEAN', label: 'Ocean' },
  { value: 'OCEAN ALEXANDER', label: 'Ocean Alexander' },
  { value: 'OCEAN STAR', label: 'Ocean Star' },
  { value: 'OCEAN VOYAGER', label: 'Ocean Voyager' },
  { value: 'OCEANCO', label: 'Oceanco' },
  { value: 'OCEANIC', label: 'Oceanic' },
  { value: 'OCHSNER', label: 'Ochsner' },
  { value: 'OCQUETEAU', label: 'Ocqueteau' },
  { value: 'ODIN', label: 'Odin' },
  { value: 'ODYSSEY', label: 'Odyssey' },
  { value: 'OFFSHORE RACING', label: 'Offshore Racing' },
  { value: 'OFFSHORE YACHTS', label: 'Offshore Yachts' },
  { value: 'OHLSON', label: 'Ohlson' },
  { value: 'OKIBOATS', label: 'Okiboats' },
  { value: 'OLBAP', label: 'Olbap' },
  { value: 'OLYMPIC', label: 'Olympic' },
  { value: 'OMIKRON YACHTS', label: 'Omikron Yachts' },
  { value: 'ONDA', label: 'Onda' },
  { value: 'ONE DESIGN', label: 'One Design' },
  { value: 'OOSTVAARDER', label: 'Oostvaarder' },
  { value: 'ORA', label: 'Ora' },
  { value: 'ORION', label: 'Orion' },
  { value: 'ORKNEY', label: 'Orkney' },
  { value: 'ORMA', label: 'Orma' },
  { value: 'OROMARINE', label: 'Oromarine' },
  { value: 'ORTONA NAVI', label: 'Ortona Navi' },
  { value: 'OSPREY', label: 'Osprey' },
  { value: 'OTAM', label: 'Otam' },
  { value: 'OUD HUIJZER', label: 'Oud Huijzer' },
  { value: 'OUTBOUND', label: 'Outbound' },
  { value: 'OUTREMER', label: 'Outremer' },
  { value: 'OVERBLUE', label: 'Overblue' },
  { value: 'OVNI', label: 'Ovni' },
  { value: 'OWENS', label: 'Owens' },
  { value: 'OYSTER', label: 'Oyster' },
  { value: 'PDQ', label: 'PDQ' },
  { value: 'PACIFIC', label: 'Pacific' },
  { value: 'PACIFIC ALLURE', label: 'Pacific Allure' },
  { value: 'PACIFIC CRAFT', label: 'Pacific Craft' },
  { value: 'PACIFIC PEARL', label: 'Pacific Pearl' },
  { value: 'PACIFIC SEACRAFT', label: 'Pacific Seacraft' },
  { value: 'PALMER JOHNSON', label: 'Palmer Johnson' },
  { value: 'PAMA', label: 'Pama' },
  { value: 'PANAMERA YACHT', label: 'Panamera Yacht' },
  { value: 'PANDORA', label: 'Pandora' },
  { value: 'PARAGON', label: 'Paragon' },
  { value: 'PARDO YACHTS', label: 'Pardo Yachts' },
  { value: 'PARITETBOAT', label: 'Paritetboat' },
  { value: 'PARKER', label: 'Parker' },
  { value: 'PARKER POLAND', label: 'Parker Poland' },
  { value: 'PASCOE', label: 'Pascoe' },
  { value: 'PASSION YACHTS', label: 'Passion Yachts' },
  { value: 'PATRIOT', label: 'Patriot' },
  { value: 'PATRONE', label: 'Patrone' },
  { value: 'PEARL', label: 'Pearl' },
  { value: 'PEARLSEA', label: 'Pearlsea' },
  { value: 'PEARSON', label: 'Pearson' },
  { value: 'PEDRAZZINI', label: 'Pedrazzini' },
  { value: 'PEDRO', label: 'Pedro' },
  { value: 'PEGASUS', label: 'Pegasus' },
  { value: 'PENDENNIS', label: 'Pendennis' },
  { value: 'PERMARE', label: 'PerMare' },
  { value: 'PERFORMANCE', label: 'Performance' },
  { value: 'PERI YACHTS', label: 'Peri Yachts' },
  { value: 'PERINI NAVI', label: 'Perini Navi' },
  { value: 'PERSHING', label: 'Pershing' },
  { value: 'PERSICO', label: 'Persico' },
  { value: 'PESCADOR', label: 'Pescador' },
  { value: 'PETTICROWS DRAGON', label: 'Petticrows Dragon' },
  { value: 'PFEIL', label: 'Pfeil' },
  { value: 'PHANTOM', label: 'Phantom' },
  { value: 'PHINISI', label: 'Phinisi' },
  { value: 'PHISA', label: 'Phisa' },
  { value: 'PHOENIX', label: 'Phoenix' },
  { value: 'PIANTONI', label: 'Piantoni' },
  { value: 'PICCHIOTTI', label: 'Picchiotti' },
  { value: 'PICULJAN', label: 'Piculjan' },
  { value: 'PIETER BEELDSNIJDER', label: 'Pieter Beeldsnijder' },
  { value: 'PIETERSE', label: 'Pieterse' },
  { value: 'PIEWIET', label: 'Piewiet' },
  { value: 'PIKMEERKRUISER', label: 'Pikmeerkruiser' },
  { value: 'PILOT', label: 'Pilot' },
  { value: 'PILOTHOUSE', label: 'Pilothouse' },
  { value: 'PILOTINA', label: 'Pilotina' },
  { value: 'PIONER', label: 'Pioner' },
  { value: 'PIRELLI', label: 'Pirelli' },
  { value: 'PLATINUM', label: 'Platinum' },
  { value: 'PLYMOUTH PILOT', label: 'Plymouth Pilot' },
  { value: 'POCA', label: 'Poca' },
  { value: 'POGO', label: 'Pogo' },
  { value: 'POLAR', label: 'Polar' },
  { value: 'POLARIS', label: 'Polaris' },
  { value: 'POLLARD', label: 'Pollard' },
  { value: 'PONCIN', label: 'Poncin' },
  { value: 'PONTOON', label: 'Pontoon' },
  { value: 'PORSCHE', label: 'Porsche' },
  { value: 'PORSIUS', label: 'Porsius' },
  { value: 'PORTIER', label: 'Portier' },
  { value: 'PORTOFINO', label: 'Portofino' },
  { value: 'PORTSMOUTH', label: 'Portsmouth' },
  { value: 'POSEIDON', label: 'Poseidon' },
  { value: 'POSILLIPO', label: 'Posillipo' },
  { value: 'POST', label: 'Post' },
  { value: 'POUVREAU', label: 'Pouvreau' },
  { value: 'POWERPLAY POWERBOATS', label: 'Powerplay Powerboats' },
  { value: 'POWERQUEST', label: 'Powerquest' },
  { value: 'PREDATOR', label: 'Predator' },
  { value: 'PREMIER', label: 'Premier' },
  { value: 'PREMIUM', label: 'Premium' },
  { value: 'PRESIDENT', label: 'President' },
  { value: 'PRESTIGE', label: 'Prestige' },
  { value: 'PRIMA', label: 'Prima' },
  { value: 'PRIMATIST', label: 'Primatist' },
  { value: 'PRIMEUR', label: 'Primeur' },
  { value: 'PRINCESS VIKING EDITION', label: 'Princess Viking Edition' },
  { value: 'PRINS', label: 'Prins' },
  { value: 'PRINZ YACHTS', label: 'Prinz Yachts' },
  { value: 'PRIVATEER', label: 'Privateer' },
  { value: 'PRIVILEGE', label: 'Privilege' },
  { value: 'PRO-LINE', label: 'Pro-Line' },
  { value: 'PROMOTOR', label: 'ProMotor' },
  { value: 'PROFICIAT', label: 'Proficiat' },
  { value: 'PROFILMARINE', label: 'Profilmarine' },
  { value: 'PROJECT', label: 'Project' },
  { value: 'PROMARINE', label: 'Promarine' },
  { value: 'PROTAGON', label: 'Protagon' },
  { value: 'PROTECTOR', label: 'Protector' },
  { value: 'PROTENDER', label: 'Protender' },
  { value: 'PROTON', label: 'Proton' },
  { value: 'PROUT', label: 'Prout' },
  { value: 'PUFFIN', label: 'Puffin' },
  { value: 'PUMA', label: 'Puma' },
  { value: 'PURSUIT', label: 'Pursuit' },
  { value: 'PYXIS YACHTS', label: 'Pyxis Yachts' },
  { value: 'QRAFTER', label: 'Qrafter' },
  { value: 'QUARKEN', label: 'Quarken' },
  { value: 'QUEENS YACHTS', label: 'Queens Yachts' },
  { value: 'QUEENSHIP', label: 'Queenship' },
  { value: 'QUER', label: 'Quer' },
  { value: 'QUICKSILVER', label: 'Quicksilver' },
  { value: 'QWEST', label: 'Qwest' },
  { value: 'RIB', label: 'RIB' },
  { value: 'RING POWERCRAFT', label: 'RING Powercraft' },
  { value: 'RIO', label: 'RIO' },
  { value: 'RM', label: 'RM' },
  { value: 'RM YACHTS', label: 'RM Yachts' },
  { value: 'RMK MARINE', label: 'RMK Marine' },
  { value: 'RS', label: 'RS' },
  { value: 'RYCK', label: 'RYCK' },
  { value: 'RADFORD', label: 'Radford' },
  { value: 'RAFFAELLI', label: 'Raffaelli' },
  { value: 'RAFNAR', label: 'Rafnar' },
  { value: 'RAIDER', label: 'Raider' },
  { value: 'RAND', label: 'Rand' },
  { value: 'RANDMEER', label: 'Randmeer' },
  { value: 'RANGER', label: 'Ranger' },
  { value: 'RANIERI', label: 'Ranieri' },
  { value: 'RAPIDO', label: 'Rapido' },
  { value: 'RAPSODY', label: 'Rapsody' },
  { value: 'RARE', label: 'Rare' },
  { value: 'RASCALA', label: 'Rascala' },
  { value: 'RAVENRIB', label: 'RavenRIB' },
  { value: 'RAYGLASS', label: 'Rayglass' },
  { value: 'REALE', label: 'Reale' },
  { value: 'REBEL', label: 'Rebel' },
  { value: 'REBORN', label: 'Reborn' },
  { value: 'REDDINGSSLOEP', label: 'Reddingssloep' },
  { value: 'REGAL', label: 'Regal' },
  { value: 'REGINA', label: 'Regina' },
  { value: 'REGO', label: 'Rego' },
  { value: 'REICHEL/PUGH', label: 'Reichel/Pugh' },
  { value: 'REINKE', label: 'Reinke' },
  { value: 'RELINE', label: 'Reline' },
  { value: 'REMUS', label: 'Remus' },
  { value: 'RENEGADE', label: 'Renegade' },
  { value: 'RENIER', label: 'Renier' },
  { value: 'RETHANA', label: 'Rethana' },
  { value: 'REVENGER', label: 'Revenger' },
  { value: 'REVOLT', label: 'Revolt' },
  { value: 'RHEA', label: 'Rhea' },
  { value: 'RHODES', label: 'Rhodes' },
  { value: 'RIB-X', label: 'Rib-X' },
  { value: 'RIB4FUN', label: 'Rib4Fun' },
  { value: 'RIBWEST', label: 'RibWest' },
  { value: 'RIBCO', label: 'Ribco' },
  { value: 'RIBEYE', label: 'Ribeye' },
  { value: 'RIBTEC', label: 'Ribtec' },
  { value: 'RICHMOND YACHTS', label: 'Richmond Yachts' },
  { value: 'RIDAS', label: 'Ridas' },
  { value: 'RIGIFLEX', label: 'Rigiflex' },
  { value: 'RINALDI', label: 'Rinaldi' },
  { value: 'RINKER', label: 'Rinker' },
  { value: 'RIO YACHTS', label: 'Rio Yachts' },
  { value: 'RISOR', label: 'Risor' },
  { value: 'RIVA', label: 'Riva' },
  { value: 'RIVAL', label: 'Rival' },
  { value: 'RIVIERA', label: 'Riviera' },
  { value: 'RIZZARDI', label: 'Rizzardi' },
  { value: 'ROBALO', label: 'Robalo' },
  { value: 'ROBERT CLARK', label: 'Robert Clark' },
  { value: 'ROBERT PERRY', label: 'Robert Perry' },
  { value: 'ROBUR', label: 'Robur' },
  { value: 'ROBUST', label: 'Robust' },
  { value: 'ROCCA', label: 'Rocca' },
  { value: 'ROCK MARINE', label: 'Rock Marine' },
  { value: 'ROCKHARBOUR', label: 'Rockharbour' },
  { value: 'RODMAN', label: 'Rodman' },
  { value: 'RON HOLLAND', label: 'Ron Holland' },
  { value: 'RONAUTICA', label: 'Ronautica' },
  { value: 'ROSETTI SUPERYACHTS', label: 'Rosetti Superyachts' },
  { value: 'ROSSINAVI', label: 'Rossinavi' },
  { value: 'ROUGHNECK', label: 'Roughneck' },
  { value: 'ROYAL CAPE CATAMARANS', label: 'Royal Cape Catamarans' },
  { value: 'ROYAL FALCON FLEET', label: 'Royal Falcon Fleet' },
  { value: 'ROYAL HUISMAN', label: 'Royal Huisman' },
  { value: 'RUBY', label: 'Ruby' },
  { value: 'RUPERT', label: 'Rupert' },
  { value: 'RUSTLER', label: 'Rustler' },
  { value: 'RYBOVICH', label: 'Rybovich' },
  { value: 'RYDS', label: 'Ryds' },
  { value: 'SACS', label: 'SACS' },
  { value: 'SAY', label: 'SAY' },
  { value: 'SHE', label: 'SHE' },
  { value: 'SK', label: 'SK' },
  { value: 'SPX RIB', label: 'SPX RIB' },
  { value: 'ST BOATS', label: 'ST Boats' },
  { value: 'STERK', label: 'STERK' },
  { value: 'SUR MARINE', label: 'SUR Marine' },
  { value: 'SAARE', label: 'Saare' },
  { value: 'SADLER', label: 'Sadler' },
  { value: 'SAFFIER', label: 'Saffier' },
  { value: 'SAGA', label: 'Saga' },
  { value: 'SAILBOAT', label: 'Sailboat' },
  { value: 'SALONA', label: 'Salona' },
  { value: 'SALPA', label: 'Salpa' },
  { value: 'SALUT', label: 'Salut' },
  { value: 'SAMSON', label: 'Samson' },
  { value: 'SAN JUAN', label: 'San Juan' },
  { value: 'SAN REMO', label: 'San Remo' },
  { value: 'SANGER', label: 'Sanger' },
  { value: 'SANGERMANI', label: 'Sangermani' },
  { value: 'SANLORENZO', label: 'Sanlorenzo' },
  { value: 'SANTASEVERA', label: 'Santasevera' },
  { value: 'SARGO', label: 'Sargo' },
  { value: 'SARNICO', label: 'Sarnico' },
  { value: 'SAS-VEKTOR', label: 'Sas-Vektor' },
  { value: 'SASGA YACHTS', label: 'Sasga Yachts' },
  { value: 'SAVER', label: 'Saver' },
  { value: 'SAXDOR', label: 'Saxdor' },
  { value: 'SCAND', label: 'Scand' },
  { value: 'SCANMAR', label: 'Scanmar' },
  { value: 'SCANNER', label: 'Scanner' },
  { value: 'SCAPE', label: 'Scape' },
  { value: 'SCARAB', label: 'Scarab' },
  { value: 'SCARANI', label: 'Scarani' },
  { value: 'SCHAEFER', label: 'Schaefer' },
  { value: 'SCHIONNING', label: 'Schionning' },
  { value: 'SCHLIEKER', label: 'Schlieker' },
  { value: 'SCHOKKER', label: 'Schokker' },
  { value: 'SCHOONER', label: 'Schooner' },
  { value: 'SCHOTTEL', label: 'Schottel' },
  { value: 'SCHOUW', label: 'Schouw' },
  { value: 'SCIALLINO', label: 'Sciallino' },
  { value: 'SCORPIO', label: 'Scorpio' },
  { value: 'SCORPION', label: 'Scorpion' },
  { value: 'SCOUT', label: 'Scout' },
  { value: 'SEA FOX', label: 'Sea Fox' },
  { value: 'SEA NYMPH', label: 'Sea Nymph' },
  { value: 'SEA PRO', label: 'Sea Pro' },
  { value: 'SEA PROP', label: 'Sea Prop' },
  { value: 'SEA RANGER', label: 'Sea Ranger' },
  { value: 'SEA RAY', label: 'Sea Ray' },
  { value: 'SEA WATER', label: 'Sea Water' },
  { value: 'SEA-DOO', label: 'Sea-Doo' },
  { value: 'SEABREEZE', label: 'Seabreeze' },
  { value: 'SEACAMPER', label: 'Seacamper' },
  { value: 'SEACODE', label: 'Seacode' },
  { value: 'SEADOG', label: 'Seadog' },
  { value: 'SEAFARING', label: 'Seafaring' },
  { value: 'SEAFURY', label: 'Seafury' },
  { value: 'SEAHORSE', label: 'Seahorse' },
  { value: 'SEALEGS', label: 'Sealegs' },
  { value: 'SEALINE', label: 'Sealine' },
  { value: 'SEALVER', label: 'Sealver' },
  { value: 'SEAMASTER', label: 'Seamaster' },
  { value: 'SEANFINITY', label: 'Seanfinity' },
  { value: 'SEAPRO', label: 'Seapro' },
  { value: 'SEAQUEST', label: 'Seaquest' },
  { value: 'SEASWIRL', label: 'Seaswirl' },
  { value: 'SEAT BOAT', label: 'Seat Boat' },
  { value: 'SEATEC', label: 'Seatec' },
  { value: 'SEAWARD', label: 'Seaward' },
  { value: 'SEAWEED', label: 'Seaweed' },
  { value: 'SEAWIND', label: 'Seawind' },
  { value: 'SELECTION BOATS', label: 'Selection Boats' },
  { value: 'SELENE', label: 'Selene' },
  { value: 'SELVA', label: 'Selva' },
  { value: 'SERENITY', label: 'Serenity' },
  { value: 'SERIOUS', label: 'Serious' },
  { value: 'SESSA MARINE', label: 'Sessa Marine' },
  { value: 'SHADOW', label: 'Shadow' },
  { value: 'SHAKESPEARE', label: 'Shakespeare' },
  { value: 'SHEARWATER', label: 'ShearWater' },
  { value: 'SHIPMAN', label: 'Shipman' },
  { value: 'SHOGUN', label: 'Shogun' },
  { value: 'SICHTERMAN', label: 'Sichterman' },
  { value: 'SIGMA', label: 'Sigma' },
  { value: 'SILTALA', label: 'Siltala' },
  { value: 'SILVER', label: 'Silver' },
  { value: 'SILVER SHIPS', label: 'Silver Ships' },
  { value: 'SILVER YACHTS', label: 'Silver Yachts' },
  { value: 'SILVERCRAFT', label: 'Silvercraft' },
  { value: 'SILVERLINE', label: 'Silverline' },
  { value: 'SILVERTON', label: 'Silverton' },
  { value: 'SINO AMERICAN YACHT', label: 'Sino American Yacht' },
  { value: 'SIRENA', label: 'Sirena' },
  { value: 'SIRIUS', label: 'Sirius' },
  { value: 'SKAGEN', label: 'Skagen' },
  { value: 'SKAGERRAK', label: 'Skagerrak' },
  { value: 'SKATER', label: 'Skater' },
  { value: 'SKILSO', label: 'Skilso' },
  { value: 'SKIMMER', label: 'Skimmer' },
  { value: 'SKIPPER-BSK', label: 'Skipper-BSK' },
  { value: 'SKORGENES', label: 'Skorgenes' },
  { value: 'SKUTSJE', label: 'Skutsje' },
  { value: 'SLEEPBOOT', label: 'Sleepboot' },
  { value: 'SLICKCRAFT', label: 'Slickcraft' },
  { value: 'SLOCUM', label: 'Slocum' },
  { value: 'SLOEP', label: 'Sloep' },
  { value: 'SLOOP', label: 'Sloop' },
  { value: 'SLY', label: 'Sly' },
  { value: 'SLYDER', label: 'Slyder' },
  { value: 'SMARTLINER', label: 'Smartliner' },
  { value: 'SMARTWAVE', label: 'Smartwave' },
  { value: 'SMELNE', label: 'Smelne' },
  { value: 'SOEL', label: 'Soel' },
  { value: 'SOGICA', label: 'Sogica' },
  { value: 'SOLARE', label: 'Solare' },
  { value: 'SOLARIS', label: 'Solaris' },
  { value: 'SOLARIS POWER', label: 'Solaris Power' },
  { value: 'SOLE POWER BOATS', label: 'Sole Power Boats' },
  { value: 'SOLEMAR', label: 'Solemar' },
  { value: 'SOLLUX', label: 'Sollux' },
  { value: 'SOUTH COAST', label: 'South Coast' },
  { value: 'SOUTHERLY', label: 'Southerly' },
  { value: 'SOUTHERN OCEAN', label: 'Southern Ocean' },
  { value: 'SOUTHERN WIND', label: 'Southern Wind' },
  { value: 'SPARKMAN & STEPHENS', label: 'Sparkman & Stephens' },
  { value: 'SPEAR', label: 'Spear' },
  { value: 'SPIRIT', label: 'Spirit' },
  { value: 'SPIRIT YACHTS', label: 'Spirit Yachts' },
  { value: 'SPITSGATTER', label: 'Spitsgatter' },
  { value: 'SQUALT MARINE', label: 'Squalt Marine' },
  { value: 'ST. FRANCIS', label: 'St. Francis' },
  { value: 'STANDFAST', label: 'Standfast' },
  { value: 'STARCRAFT', label: 'Starcraft' },
  { value: 'STARCRUISER', label: 'Starcruiser' },
  { value: 'STARFISHER', label: 'Starfisher' },
  { value: 'STAVERSE KOTTER', label: 'Staverse Kotter' },
  { value: 'STEALTH', label: 'Stealth' },
  { value: 'STEELCRAFT', label: 'Steelcraft' },
  { value: 'STEELER', label: 'Steeler' },
  { value: 'STEFINI', label: 'Stefini' },
  { value: 'STENTOR', label: 'Stentor' },
  { value: 'STERLING', label: 'Sterling' },
  { value: 'STERLING YACHTS', label: 'Sterling Yachts' },
  { value: 'STEVENS', label: 'Stevens' },
  { value: 'STEVENVLET', label: 'Stevenvlet' },
  { value: 'STIL', label: 'Stil' },
  { value: 'STILMAR', label: 'Stilmar' },
  { value: 'STINGHER', label: 'Stingher' },
  { value: 'STINGRAY', label: 'Stingray' },
  { value: 'STOREBRO', label: 'Storebro' },
  { value: 'STORM', label: 'Storm' },
  { value: 'STORMER', label: 'Stormer' },
  { value: 'STOUT', label: 'Stout' },
  { value: 'STRATOS', label: 'Stratos' },
  { value: 'STRIKER', label: 'Striker' },
  { value: 'STURIER', label: 'Sturier' },
  { value: 'SUCCES', label: 'Succes' },
  { value: 'SUN HING SHING', label: 'Sun Hing Shing' },
  { value: 'SUNBEAM', label: 'Sunbeam' },
  { value: 'SUNDECK YACHTS', label: 'Sundeck Yachts' },
  { value: 'SUNDEER', label: 'Sundeer' },
  { value: 'SUNPOWER', label: 'Sunpower' },
  { value: 'SUNREEF', label: 'Sunreef' },
  { value: 'SUNRISE', label: 'Sunrise' },
  { value: 'SUPER LAUWERSMEER', label: 'Super Lauwersmeer' },
  { value: 'SUPER VAN CRAFT', label: 'Super Van Craft' },
  { value: 'SUPERCRAFT', label: 'Supercraft' },
  { value: 'SUPERMARINE', label: 'Supermarine' },
  { value: 'SUPERYACHT', label: 'Superyacht' },
  { value: 'SUPREME', label: 'Supreme' },
  { value: 'SUZUMAR', label: 'Suzumar' },
  { value: 'SWEDEN YACHTS', label: 'Sweden Yachts' },
  { value: 'SWISS CAT YACHTS', label: 'Swiss Cat Yachts' },
  { value: 'SWORDFISH', label: 'Swordfish' },
  { value: 'SWORDSMAN', label: 'Swordsman' },
  { value: 'TMBOATS', label: 'TMBoats' },
  { value: 'TORGEM', label: 'TORGEM' },
  { value: 'TA CHIAO', label: 'Ta Chiao' },
  { value: 'TA SHING', label: 'Ta Shing' },
  { value: 'TAHITI', label: 'Tahiti' },
  { value: 'TALAMEX', label: 'Talamex' },
  { value: 'TALING', label: 'Taling' },
  { value: 'TANKOA', label: 'Tankoa' },
  { value: 'TARGA', label: 'Targa' },
  { value: 'TARGET', label: 'Target' },
  { value: 'TARPON', label: 'Tarpon' },
  { value: 'TARTAN', label: 'Tartan' },
  { value: 'TASWELL', label: 'Taswell' },
  { value: 'TAYANA', label: 'Tayana' },
  { value: 'TAYLOR', label: 'Taylor' },
  { value: 'TECHNOHULL', label: 'Technohull' },
  { value: 'TECHNOLOGIE MARINE', label: 'Technologie Marine' },
  { value: 'TECNOMAR', label: 'Tecnomar' },
  { value: 'TECNOMARINE', label: 'Tecnomarine' },
  { value: 'TECNORIB', label: 'Tecnorib' },
  { value: 'TEKNO-MARINE', label: 'Tekno-Marine' },
  { value: 'TEMPO', label: 'Tempo' },
  { value: 'TEN BROEKE', label: 'Ten Broeke' },
  { value: 'TENDR', label: 'TendR' },
  { value: 'TENDER', label: 'Tender' },
  { value: 'TERHI', label: 'Terhi' },
  { value: 'TERRANOVA YACHTS', label: 'Terranova Yachts' },
  { value: 'TES', label: 'Tes' },
  { value: 'TESORO', label: 'Tesoro' },
  { value: 'TEST', label: 'Test' },
  { value: 'TEXAS', label: 'Texas' },
  { value: 'THEONE', label: 'TheOne' },
  { value: 'THOMASZ', label: 'Thomasz' },
  { value: 'THORNYCROFT', label: 'Thornycroft' },
  { value: 'THUNDERCRAFT', label: 'Thundercraft' },
  { value: 'TIARA YACHTS', label: 'Tiara Yachts' },
  { value: 'TIGER MARINE', label: 'Tiger Marine' },
  { value: 'TIGÉ', label: 'Tigé' },
  { value: 'TINN-SILVER', label: 'Tinn-Silver' },
  { value: 'TJALK', label: 'Tjalk' },
  { value: 'TOFINOU', label: 'Tofinou' },
  { value: 'TOLLYCRAFT', label: 'Tollycraft' },
  { value: 'TOPAZ', label: 'Topaz' },
  { value: 'TOPCRAFT', label: 'Topcraft' },
  { value: 'TOR', label: 'Tor' },
  { value: 'TORNADO', label: 'Tornado' },
  { value: 'TOY', label: 'Toy' },
  { value: 'TRADER', label: 'Trader' },
  { value: 'TRADEWIND', label: 'Tradewind' },
  { value: 'TRAWLER', label: 'Trawler' },
  { value: 'TREFFER', label: 'Treffer' },
  { value: 'TREHARD', label: 'Trehard' },
  { value: 'TRESFJORD', label: 'Tresfjord' },
  { value: 'TREWES', label: 'Trewes' },
  { value: 'TRIAD', label: 'Triad' },
  { value: 'TRIDENT', label: 'Trident' },
  { value: 'TRIMARAN', label: 'Trimaran' },
  { value: 'TRIMARCHI', label: 'Trimarchi' },
  { value: 'TRINITY YACHTS', label: 'Trinity Yachts' },
  { value: 'TRINTELLA', label: 'Trintella' },
  { value: 'TRIPP', label: 'Tripp' },
  { value: 'TRITON', label: 'Triton' },
  { value: 'TRUMPY', label: 'Trumpy' },
  { value: 'TRUSTY', label: 'Trusty' },
  { value: 'TULLIO ABBATE', label: 'Tullio Abbate' },
  { value: 'TUNA', label: 'Tuna' },
  { value: 'TURQUOISE', label: 'Turquoise' },
  { value: 'TYLER', label: 'Tyler' },
  { value: 'TYVANO', label: 'Tyvano' },
  { value: 'ULTIMATE BOATS', label: 'Ultimate Boats' },
  { value: 'ULTRAMAR', label: 'Ultramar' },
  { value: 'UNIESSE', label: 'Uniesse' },
  { value: 'UTTERN', label: 'Uttern' },
  { value: 'VSR', label: 'VSR' },
  { value: 'VTS', label: 'VTS' },
  { value: 'VZ', label: 'VZ' },
  { value: 'VAAN', label: 'Vaan' },
  { value: 'VACANCE', label: 'Vacance' },
  { value: 'VAGABOND', label: 'Vagabond' },
  { value: 'VALENTINO', label: 'Valentino' },
  { value: 'VALHALLA BOATWORKS', label: 'Valhalla Boatworks' },
  { value: 'VALIANT', label: 'Valiant' },
  { value: 'VALIANT RIBS', label: 'Valiant RIBs' },
  { value: 'VALK', label: 'Valk' },
  { value: 'VALKKRUISER', label: 'Valkkruiser' },
  { value: 'VALKVLET', label: 'Valkvlet' },
  { value: 'VALORY', label: 'Valory' },
  { value: 'VAN BAERDT', label: 'Van Baerdt' },
  { value: 'VAN DAM', label: 'Van Dam' },
  { value: 'VAN DE STADT', label: 'Van De Stadt' },
  { value: 'VAN LENT', label: 'Van Lent' },
  { value: 'VAN VOSSEN', label: 'Van Vossen' },
  { value: 'VAN WIJK', label: 'Van Wijk' },
  { value: 'VAN DEN AKKER', label: 'Van den Akker' },
  { value: 'VAN DEN HOVEN', label: 'Van den Hoven' },
  { value: 'VAN DER HEIJDEN', label: 'Van der Heijden' },
  { value: 'VAN DER VALK', label: 'Van der Valk' },
  { value: 'VANDUTCH', label: 'VanDutch' },
  { value: 'VANVOSSEN', label: 'VanVossen' },
  { value: 'VANCOUVER', label: 'Vancouver' },
  { value: 'VANGUARD', label: 'Vanguard' },
  { value: 'VANQUISH', label: 'Vanquish' },
  { value: 'VANQUISH YACHTS', label: 'Vanquish Yachts' },
  { value: 'VEDETTE', label: 'Vedette' },
  { value: 'VEHA', label: 'Veha' },
  { value: 'VELMARE', label: 'Velmare' },
  { value: 'VELOCE YACHTS', label: 'Veloce Yachts' },
  { value: 'VENEGY', label: 'Venegy' },
  { value: 'VENNEKENS', label: 'Vennekens' },
  { value: 'VENTURA', label: 'Ventura' },
  { value: 'VENTUS', label: 'Ventus' },
  { value: 'VERHOEF', label: 'Verhoef' },
  { value: 'VERHOEVEN', label: 'Verhoeven' },
  { value: 'VERSILCRAFT', label: 'Versilcraft' },
  { value: 'VETUS', label: 'Vetus' },
  { value: 'VICEM', label: 'Vicem' },
  { value: 'VICTOIRE', label: 'Victoire' },
  { value: 'VICTORIA', label: 'Victoria' },
  { value: 'VIKING', label: 'Viking' },
  { value: 'VIKING BOATS', label: 'Viking Boats' },
  { value: 'VIKING MARIN', label: 'Viking Marin' },
  { value: 'VIKNES', label: 'Viknes' },
  { value: 'VIKO', label: 'Viko' },
  { value: 'VIKSUND', label: 'Viksund' },
  { value: 'VILM', label: 'Vilm' },
  { value: 'VINDO', label: 'Vindo' },
  { value: 'VINTAGE', label: 'Vintage' },
  { value: 'VIPER', label: 'Viper' },
  { value: 'VIPER BOATS', label: 'Viper Boats' },
  { value: 'VIRTUE', label: 'Virtue' },
  { value: 'VISION', label: 'Vision' },
  { value: 'VISMARA', label: 'Vismara' },
  { value: 'VITECH', label: 'Vitech' },
  { value: 'VITTERS', label: 'Vitters' },
  { value: 'VLET', label: 'Vlet' },
  { value: 'VOLKERAK', label: 'Volkerak' },
  { value: 'VORAZ', label: 'Voraz' },
  { value: 'VOYAGE YACHTS', label: 'Voyage Yachts' },
  { value: 'VRI-JON', label: 'Vri-Jon' },
  { value: 'VRIPACK', label: 'Vripack' },
  { value: 'W.A. SOUTER & SONS', label: 'W.A. Souter & Sons' },
  { value: 'WHISPER YACHTS', label: 'WHISPER YACHTS' },
  { value: 'WAARSCHIP', label: 'Waarschip' },
  { value: 'WAHOO', label: 'Wahoo' },
  { value: 'WAJER', label: 'Wajer' },
  { value: 'WALLY', label: 'Wally' },
  { value: 'WALSTEDS', label: 'Walsteds' },
  { value: 'WARRIOR', label: 'Warrior' },
  { value: 'WASA', label: 'Wasa' },
  { value: 'WATERBUS', label: 'Waterbus' },
  { value: 'WATERDREAM', label: 'Waterdream' },
  { value: 'WATERLAND', label: 'Waterland' },
  { value: 'WATERLINE', label: 'Waterline' },
  { value: 'WATERSPOOR', label: 'Waterspoor' },
  { value: 'WATO', label: 'Wato' },
  { value: 'WAUQUIEZ', label: 'Wauquiez' },
  { value: 'WAVE', label: 'Wave' },
  { value: 'WECO', label: 'WeCo' },
  { value: 'WELLCRAFT', label: 'Wellcraft' },
  { value: 'WEST BAY', label: 'West Bay' },
  { value: 'WESTBAS', label: 'Westbas' },
  { value: 'WESTER ENGH', label: 'Wester Engh' },
  { value: 'WESTERLY', label: 'Westerly' },
  { value: 'WESTPORT', label: 'Westport' },
  { value: 'WEYMOUTH', label: 'Weymouth' },
  { value: 'WHALY', label: 'Whaly' },
  { value: 'WHARRAM', label: 'Wharram' },
  { value: 'WHITE BROTHERS', label: 'White Brothers' },
  { value: 'WHITE SHARK', label: 'White Shark' },
  { value: 'WHITEWATER', label: 'Whitewater' },
  { value: 'WHITMARSH', label: 'Whitmarsh' },
  { value: 'WIBO', label: 'Wibo' },
  { value: 'WIDER', label: 'Wider' },
  { value: 'WILLIAM FIFE', label: 'William Fife' },
  { value: 'WILLIAMS JET TENDERS', label: 'Williams Jet Tenders' },
  { value: 'WIMBI BOATS', label: 'Wimbi Boats' },
  { value: 'WINDELO', label: 'Windelo' },
  { value: 'WINDSHIP', label: 'Windship' },
  { value: 'WINDY', label: 'Windy' },
  { value: 'WING', label: 'Wing' },
  { value: 'WINNER', label: 'Winner' },
  { value: 'WORLD CAT', label: 'World Cat' },
  { value: 'X SHORE', label: 'X Shore' },
  { value: 'X-YACHTS', label: 'X-Yachts' },
  { value: 'XO BOATS', label: 'XO Boats' },
  { value: 'YAM', label: 'YAM' },
  { value: 'YOT', label: 'YOT' },
  { value: 'YYACHTS', label: 'YYachts' },
  { value: 'YACHTING FRANCE', label: 'Yachting France' },
  { value: 'YAMAHA BOATS', label: 'Yamaha Boats' },
  { value: 'YAMAHA WAVERUNNER', label: 'Yamaha WaveRunner' },
  { value: 'YAMARIN', label: 'Yamarin' },
  { value: 'YANMAR', label: 'Yanmar' },
  { value: 'YARETTI', label: 'Yaretti' },
  { value: 'YELLOWFIN', label: 'Yellowfin' },
  { value: 'ZAR MINI', label: 'ZAR Mini' },
  { value: 'ZEE', label: 'ZEE' },
  { value: 'ZAR', label: 'Zar' },
  { value: 'ZAR FORMENTI', label: 'Zar Formenti' },
  { value: 'ZARRO', label: 'Zarro' },
  { value: 'ZEELANDER', label: 'Zeelander' },
  { value: 'ZEESCHOUW', label: 'Zeeschouw' },
  { value: 'ZEGERS', label: 'Zegers' },
  { value: 'ZEILKOTTER', label: 'Zeilkotter' },
  { value: 'ZEPHYR', label: 'Zephyr' },
  { value: 'ZEPPELIN INFLATABLES', label: 'Zeppelin Inflatables' },
  { value: 'ZETA ELLE', label: 'Zeta Elle' },
  { value: 'ZIJLMANS', label: 'Zijlmans' },
  { value: 'ZODIAC', label: 'Zodiac' },
  { value: 'ZODIAC MILPRO', label: 'Zodiac Milpro' },
  { value: 'ZUANELLI', label: 'Zuanelli' },
  { value: 'ZUIDERZEE', label: 'Zuiderzee' },
  { value: 'ZWAAN', label: 'Zwaan' },
  { value: 'E SAILING YACHTS', label: 'e Sailing Yachts' },
  { value: 'VAN VLIET', label: 'van Vliet' },
];

export const LISTING_BRANDS_FOR_TYPE = {
  [LISTING_TYPE.AIRBOAT]: {
    // brands goes here
  },
  [LISTING_TYPE.BOWRIDER]: {
    // brands goes here
  },
  [LISTING_TYPE.BUOY]: {
    // brands goes here
  },
  [LISTING_TYPE.CABIN]: {
    // brands goes here
  },
  [LISTING_TYPE.CANOE]: {
    // brands goes here
  },
  [LISTING_TYPE.CARGO]: {
    // brands goes here
  },
  [LISTING_TYPE.CATAMARAN]: {
    // brands goes here
  },
  [LISTING_TYPE.CENTER_CONSOLE]: {
    // brands goes here
  },
  [LISTING_TYPE.CLASSIC]: {
    // brands goes here
  },
  [LISTING_TYPE.COVERS]: {
    // brands goes here
  },
  [LISTING_TYPE.CRUISER]: {
    // brands goes here
  },
  [LISTING_TYPE.CRUISING]: {
    // brands goes here
  },
  [LISTING_TYPE.CUDDY_CABIN]: {
    // brands goes here
  },
  [LISTING_TYPE.DAY_CRUISER]: {
    // brands goes here
  },
  [LISTING_TYPE.DAYSAILER]: {
    // brands goes here
  },
  [LISTING_TYPE.DECK]: {
    // brands goes here
  },
  [LISTING_TYPE.DECKSALOON]: {
    // brands goes here
  },
  [LISTING_TYPE.DINGHY]: {
    // brands goes here
  },
  [LISTING_TYPE.DIVING]: {
    // brands goes here
  },
  [LISTING_TYPE.DUAL_CONSOLE]: {
    // brands goes here
  },
  [LISTING_TYPE.ENTERTAINMENT]: {
    // brands goes here
  },
  [LISTING_TYPE.FISHING]: {
    // brands goes here
  },
  [LISTING_TYPE.FLAT]: {
    // brands goes here
  },
  [LISTING_TYPE.FLOATING_HOME]: {
    // brands goes here
  },
  [LISTING_TYPE.GULET]: {
    // brands goes here
  },
  [LISTING_TYPE.HANGAR_HEATED]: {
    // brands goes here
  },
  [LISTING_TYPE.HANGAR_UNHEATED]: {
    // brands goes here
  },
  [LISTING_TYPE.HARBOUR]: {
    // brands goes here
  },
  [LISTING_TYPE.HARD_TOP]: {
    // brands goes here
  },
  [LISTING_TYPE.HIGH_PERFORMANCE]: {
    // brands goes here
  },
  [LISTING_TYPE.HOUSE_BOAT]: {
    // brands goes here
  },
  [LISTING_TYPE.HULL]: {
    // brands goes here
  },
  [LISTING_TYPE.INBOARD]: {
    // brands goes here
  },
  [LISTING_TYPE.INTERIOR]: {
    // brands goes here
  },
  [LISTING_TYPE.JETTY]: {
    // brands goes here
  },
  [LISTING_TYPE.KAYAK]: {
    // brands goes here
  },
  [LISTING_TYPE.LAYOUT]: {
    // brands goes here
  },
  [LISTING_TYPE.MOTORSAILER]: {
    // brands goes here
  },
  [LISTING_TYPE.NARROW]: {
    // brands goes here
  },
  [LISTING_TYPE.NAVIGATION]: {
    // brands goes here
  },
  [LISTING_TYPE.OTHER]: {
    // brands goes here
  },
  [LISTING_TYPE.OUTBOARD]: {
    // brands goes here
  },
  [LISTING_TYPE.PASSENGER]: {
    // brands goes here
  },
  [LISTING_TYPE.PEDAL]: {
    // brands goes here
  },
  [LISTING_TYPE.PILOT_HOUSE]: {
    // brands goes here
  },
  [LISTING_TYPE.PONTOON]: {
    // brands goes here
  },
  [LISTING_TYPE.RACING]: {
    // brands goes here
  },
  [LISTING_TYPE.RAFTING]: {
    // brands goes here
  },
  [LISTING_TYPE.RIB]: {
    // brands goes here
  },
  [LISTING_TYPE.ROAD]: {
    // brands goes here
  },
  [LISTING_TYPE.ROWING]: {
    // brands goes here
  },
  [LISTING_TYPE.RUNABOUT]: {
    // brands goes here
  },
  [LISTING_TYPE.SAFETY]: {
    // brands goes here
  },
  [LISTING_TYPE.SKI_AND_WAKE]: {
    // brands goes here
  },
  [LISTING_TYPE.SLOEP]: {
    // brands goes here
  },
  [LISTING_TYPE.SOFT]: {
    // brands goes here
  },
  [LISTING_TYPE.SPORT]: {
    // brands goes here
  },
  [LISTING_TYPE.STORAGE]: {
    // brands goes here
  },
  [LISTING_TYPE.SUBMARINE]: {
    // brands goes here
  },
  [LISTING_TYPE.SWIMMING]: {
    // brands goes here
  },
  [LISTING_TYPE.TECHNICS]: {
    // brands goes here
  },
  [LISTING_TYPE.TRAWLER]: {
    // brands goes here
  },
  [LISTING_TYPE.TRIMARAN]: {
    // brands goes here
  },
  [LISTING_TYPE.TROLLEY]: {
    // brands goes here
  },
  [LISTING_TYPE.UTILITY]: {
    // brands goes here
  },
  [LISTING_TYPE.WALKAROUND]: {
    // brands goes here
  },
  [LISTING_TYPE.YACHT]: {
    // brands goes here
  },
};
